/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from '@tanstack/react-query';
import { fetcher } from './fetcher';

/** All built-in and custom scalars, mapped to their actual values */

/** Represents the actor who performed the event. */

/** Defines the type of actor performing the event. */
export let ActorType = /*#__PURE__*/function (ActorType) {
  /** Represents an end user who performed the action. */
  ActorType["EndUser"] = "END_USER";
  /** Represents an impersonation of another user performing the action. */
  ActorType["Impersonation"] = "IMPERSONATION";
  /** Represents a service or automated system performing the action. */
  ActorType["Service"] = "SERVICE";
  return ActorType;
}({});

/** Gen AI-related organization settings */

/** Price option for computed price plan. Will be returned for annual plans */

/** An API client */

/** Response from creating an API client containing ApiClient info and client's secret */

/** Response from deleting an API client containing the deleted API Client ID */

/** An API client for an Organization */

/** An API client for a Partner */

/** Input for creating an API client */

/** Article lecture */

/** Article lecture */

/**
 * An Assessment represents a collection of Forms (which are variations of items and orderings of items).
 * A user chooses to take an Assessment. They are then give a Form to take from that Assessment.
 */

/** A unique assignment of an assessment to a user, with optional due date */

/** An attempt of an assessment by a learner */

/** Score stats for an attempt of an assessment */

/** Attempt summary for an assessment with its attempts and remaining attempt count */

/** A domain associated with an assessment */

/** A form represents a specific variation of an assessment with a particular set and ordering of items */

/** An AssessmentItem contains data about the item a user can interact with. */

/** An  AssessmentItemAttempt is an item related to an Assessment that contains how a user performed in an AssessmentItem. */

/** Input for submitting an attempt of an assessment item */

/** Contains the valid item attempt status for an item attempt. */
export let AssessmentItemAttemptStatus = /*#__PURE__*/function (AssessmentItemAttemptStatus) {
  /** The user answered the item correctly */
  AssessmentItemAttemptStatus["Correct"] = "CORRECT";
  /** The user answered the item incorrectly */
  AssessmentItemAttemptStatus["Incorrect"] = "INCORRECT";
  /** The user skipped the item */
  AssessmentItemAttemptStatus["Skipped"] = "SKIPPED";
  return AssessmentItemAttemptStatus;
}({});

/** Input for submitting feedback for an assessment item */

/** Type of feedback provided for an assessment item */
export let AssessmentItemFeedbackType = /*#__PURE__*/function (AssessmentItemFeedbackType) {
  /** Feedback for accuracy issues */
  AssessmentItemFeedbackType["Accuracy"] = "ACCURACY";
  /** Feedback for formatting issues */
  AssessmentItemFeedbackType["Formatting"] = "FORMATTING";
  /** Other feedback */
  AssessmentItemFeedbackType["Other"] = "OTHER";
  /** Feedback for irrelevant content */
  AssessmentItemFeedbackType["Relevance"] = "RELEVANCE";
  /** Feedback for wording issues */
  AssessmentItemFeedbackType["Wording"] = "WORDING";
  return AssessmentItemFeedbackType;
}({});

/** Option for multiple-choice or multi-select type questions */

/** Filters used to fetch user assessment items results that are correct, skipped and attempted. */

/** Type of the Assessment item */
export let AssessmentItemType = /*#__PURE__*/function (AssessmentItemType) {
  /** Multiple choice item type */
  AssessmentItemType["MultipleChoice"] = "MULTIPLE_CHOICE";
  /** Multiple select item type */
  AssessmentItemType["MultiSelect"] = "MULTI_SELECT";
  return AssessmentItemType;
}({});

/** MetaData for an assessment */

/** A wrapper type to include the recommended Assessment and some additional fields about its recommendation */

/**
 * An AssessmentResults represents a user results for taking an Assessment.
 * items are the attempts of the latest form the User attempted for an Assessment.
 */

/** List of Assessment and additional data about search response */

/** Contains info for front end related stuff and tracking info. This data is calculated by backend service and used by Udemy front end. If you are an external user, you shouldn't need this. */

/** Detailed metrics for a specific skill/assessment */

/** Input for skills breakdown query */

/** Paginated list for assessment summary list */

/** Sort order options for skills breakdown */

/** Assessment activity data point for a specific day */

/**
 * A 'variant' is an instance/representation of an assessment used for having its own dynamic list of questions (deprecated)
 *
 * There may exist multiple variants of the same assessment, which share the same pool of questions, uniquely ordered between variants. Each variant will have a unique id, and will be associated with one assessment from which the questions are drawn.
 */

/** Top level object to track the progress and results of a user taking an assessment variant (deprecated) */

/** An evaluation of a completed attempt (deprecated) */

/** An asset is a fundamental resource unit (like images, videos, subtitles, texts) for building learning experiences at Udemy. Asset endpoint provides metadata, the storage location, access permission and its type. */

/** Represents an article asset, including download information and article content. */

/** Represents an audio asset, including download information, captions, and DRM status. */

/** Captions are the WebVTT standard files needed for rendering subtitles */

/** Download information for a given asset */

/** Represents an ebook asset */

/** Represents an external link asset, typically used for linking to external resources or websites. */

/** Represents a file asset, including download information and file type. */

/**
 * Categories for file asset types. These categories roughly map to MIME types.
 * See https://developer.mozilla.org/en-US/docs/Web/HTTP/Guides/MIME_types/Common_types for details
 */
export let AssetFileType = /*#__PURE__*/function (AssetFileType) {
  /** Roughly equivalent to code-like MIME types (text/html, text/javascript, text/css, etc.); A code file */
  AssetFileType["Code"] = "CODE";
  /** Roughly equivalent to document-like MIME types (application/pdf, text/markdown, etc.); A document file */
  AssetFileType["Document"] = "DOCUMENT";
  /** Roughly equivalent to image-like MIME types (e.g. image/jpeg, image/gif, etc.); An image file */
  AssetFileType["Image"] = "IMAGE";
  /** Equivalent to application/octet-stream; Default for all other non-textual cases. */
  AssetFileType["Other"] = "OTHER";
  /** Equivalent to text/plain; Default for textual file cases. A textual (.txt) file should be human-readable and must not contain binary data. */
  AssetFileType["Text"] = "TEXT";
  /** Roughly equivalent to zip-like MIME types (e.g. application/gzip, application/zip, etc.); A compressed archive file */
  AssetFileType["Zip"] = "ZIP";
  return AssetFileType;
}({});

/** Represents an iframe asset */

/** Represents an imported content asset */

/** Media source provides the info to download and stream the media artifacts */

/** Represents a presentation asset */

/** Represents a source code asset */

/** Status of asset processing. */
export let AssetStatus = /*#__PURE__*/function (AssetStatus) {
  /** The caption processing failed. */
  AssetStatus["Failed"] = "FAILED";
  /** The caption is currently being processed. */
  AssetStatus["Processing"] = "PROCESSING";
  /** The caption was processed successfully. */
  AssetStatus["Success"] = "SUCCESS";
  /** The caption is unprocessed. */
  AssetStatus["Unprocessed"] = "UNPROCESSED";
  return AssetStatus;
}({});

/** Thumbnail tracks are used for sneak-peek feature. provides a composite image and a metadata file with a timestamp and cartesian plane co-ordinates of a image rectangle. */

/** Represents a video asset, including download information, captions, and DRM status. */

/** Represents a Video Mashup asset, including download information and file type. */

/** Lecture in the form of just audio (deprecated) */

/** Lecture in the form of just audio (deprecated) */

/** Defines what chat format configuration should be used for assistant messages */

/** Defines the types of events that occurred. */
export let AuditEvent = /*#__PURE__*/function (AuditEvent) {
  /** A user has been assigned by csv. */
  AuditEvent["AssignUsersByCsv"] = "ASSIGN_USERS_BY_CSV";
  /** A group has been created. */
  AuditEvent["GroupCreated"] = "GROUP_CREATED";
  /** A group has been deleted. */
  AuditEvent["GroupDeleted"] = "GROUP_DELETED";
  /** A group has been edited. */
  AuditEvent["GroupEdited"] = "GROUP_EDITED";
  /** An invitation has been created. */
  AuditEvent["InvitationCreated"] = "INVITATION_CREATED";
  /** A license has been created. */
  AuditEvent["LicenseActivated"] = "LICENSE_ACTIVATED";
  /** A license has been deactivated. */
  AuditEvent["LicenseDeactivated"] = "LICENSE_DEACTIVATED";
  /** A user has been activated. */
  AuditEvent["UserActivated"] = "USER_ACTIVATED";
  /** A user has been anonymized. */
  AuditEvent["UserAnonymized"] = "USER_ANONYMIZED";
  /** A user has been created. */
  AuditEvent["UserCreated"] = "USER_CREATED";
  /** A user has been deactivated. */
  AuditEvent["UserDeactivated"] = "USER_DEACTIVATED";
  /** A user email has been edited. */
  AuditEvent["UserEmailEdited"] = "USER_EMAIL_EDITED";
  /** A user list has been exported to csv. */
  AuditEvent["UserListExportedToCsv"] = "USER_LIST_EXPORTED_TO_CSV";
  /** A user is pending. */
  AuditEvent["UserPending"] = "USER_PENDING";
  /** A user has been reactivated. */
  AuditEvent["UserReactivated"] = "USER_REACTIVATED";
  /** A user role has been assigned. */
  AuditEvent["UserRoleAssigned"] = "USER_ROLE_ASSIGNED";
  /** A user role has been edited. */
  AuditEvent["UserRoleEdited"] = "USER_ROLE_EDITED";
  /** A user has been updated. */
  AuditEvent["UserUpdated"] = "USER_UPDATED";
  return AuditEvent;
}({});

/** Input type for filtering logs based on a date time range. */

/** Authentication credentials for accessing an AWS cloud lab instance */

/** Authentication credentials for accessing an Azure cloud lab instance */

/** Issued Badge of a user (Assertion in OpenBadge specification) */

/** Response for storing assertion (which is given as external url) for current user */

/** Response for deleting assertion of current user */

/** Issued badges of a user (Assertion in OpenBadge specification) */

/** Search filters for Badge Assertion search */

/** Certification Provider (topic descriptor) for Open Badges */

/** Certification Subject Area (topic descriptor) for Open Badges */

/** The BadgeClass interface. A collection of information about the accomplishment recognized by the Open Badge. It means Certification for the most cases. */

/** Alignment object. An intangible item that describes an alignment between a learning resource and a BadgeClass */

/** Input for BadgeClassAlignment */

/** Descriptive metadata about the achievements necessary to be issued with particular BadgeClass (Certification). */

/** Enrolled learning products for a badge class */

/** Image object of BadgeClass or Issuer */

/** Issuer of BadgeClass. A collection of information that describes the entity or organization */

/** Register a badge issuer for an organization */

/** Response for registering a badge issuer for an organization */

/** Search filters for Organization BadgeClasses search */

/** Search filters for BadgeClass search */

/** Paginated list of BadgeClasses for search response */

/** Wrapped response type for BadgeClass mutations */

/** Input for updating a badge classes by topicId */

/** Input for updating a badge classes by visibilityStatus */

/** Visibility of the badge class on the Udemy platform */
export let BadgeClassVisibilityStatus = /*#__PURE__*/function (BadgeClassVisibilityStatus) {
  /** Deleted badges */
  BadgeClassVisibilityStatus["Deleted"] = "DELETED";
  /** Hidden from users on the platform */
  BadgeClassVisibilityStatus["Hidden"] = "HIDDEN";
  /** Visible to users on the platform, but not discoverable in search */
  BadgeClassVisibilityStatus["InstructorIssued"] = "INSTRUCTOR_ISSUED";
  /** Visible to users on the platform, but not discoverable in search, and only visible to users in the issuing organization */
  BadgeClassVisibilityStatus["Organization"] = "ORGANIZATION";
  /** Hidden from users on the platform, awaiting content or planning updates */
  BadgeClassVisibilityStatus["Pending"] = "PENDING";
  /** Visible to all users */
  BadgeClassVisibilityStatus["Visible"] = "VISIBLE";
  return BadgeClassVisibilityStatus;
}({});

/** Badge enrollment */

/** Response object for badge issuance CSV upload */

/** SubCategory with no additional fields */

/** Represents a badge awarded to a beginner top-rated category topic. */

/** Represents a badge awarded to a beginner top-rated subcategory. */

/** Represents a badge awarded to a beginner top-rated subcategory topic. */

/** Represents a badge awarded to a best seller category topic. */

/** Represents a badge awarded to a best seller subcategory. */

/** Represents a badge awarded to a best seller subcategory topic. */

/** The source of the caption: user-uploaded or automatically generated. */
export let CaptionSource = /*#__PURE__*/function (CaptionSource) {
  /** Automatically generated caption. */
  CaptionSource["Auto"] = "AUTO";
  /** User uploaded caption. */
  CaptionSource["Manual"] = "MANUAL";
  return CaptionSource;
}({});

/** Types of captions */
export let CaptionType = /*#__PURE__*/function (CaptionType) {
  /** Captions covering speech and descriptions of non-spoken sounds */
  CaptionType["ClosedCaption"] = "CLOSED_CAPTION";
  /** Captions covering speech only */
  CaptionType["Subtitle"] = "SUBTITLE";
  return CaptionType;
}({});

/** The Career Accelerator object. */

/** An article associated with a Career Accelerator. */

/** An author of a Career Accelerator article. */

/** A Career object representing a specific career path or field. */

/** A CareerHeroImage object representing hero images associated with a Career. */

/** A CareerImage object representing images associated with a Career. */

/** A Certificate Info object representing information about the certificate an accelerator might give a user (Udemy and/or OpenBadge.) This is NOT the user's actual certificate. */

/** CareerAccelerator collection specific properties */

/** Stats related to the items in the career accelerator */

/** A curriculum for a Career Accelerator, containing sections and items. */

/** A curriculum item in the Career Accelerator, representing a learning product. */

/** A section in the Career Accelerator curriculum, containing items. */

/** Career accelerator enrollment */

/** Paged career accelerator enrollments */

/** A Frequently Asked Question (FAQ) for a Career Accelerator. */

/** Learning outcome for a Career Accelerator curriculum item. */

/** A subject within a Career Accelerator curriculum item. */

/** A user testimonial for a Career Accelerator. */

/** The source of a Career Accelerator testimonial. */

/** Defines the type of testimonials available for Career Accelerators. */
export let CareerAcceleratorTestimonialType = /*#__PURE__*/function (CareerAcceleratorTestimonialType) {
  /** A testimonial type representing a course review */
  CareerAcceleratorTestimonialType["CourseReview"] = "COURSE_REVIEW";
  /** A testimonial type representing a third party learning testimonial */
  CareerAcceleratorTestimonialType["ThirdParty"] = "THIRD_PARTY";
  return CareerAcceleratorTestimonialType;
}({});

/** Input type for filtering Career Accelerators. */

/** Cursor paginated Career Accelerators. */

/** Category the Course belongs to */

/** Category navigation list item. */

/** A wrapper type to include the recommended Category and some additional fields about its recommendation */

/** Certification Exam for earning a Badge */

/** Certification Exam for earning a Badge */

/** Certification Exam for earning a Badge */

/** URL to the exam registration page for a certification with its locale (deprecated) */

/** A voucher instance */

/** Primary entity representing a certification exam */

/** FAQ style data for the voucher exam */

/** Paginated certification voucher exams response */

/** Metadata and state for a group of vouchers */

/** FAQ style data for the voucher pool */

/** Paginated certification voucher pools response */

/** Details about a certification provider */

/** Certification provider for voucher exams */
export let CertificationVoucherProviderType = /*#__PURE__*/function (CertificationVoucherProviderType) {
  /** AWS certification provider */
  CertificationVoucherProviderType["Aws"] = "AWS";
  /** CompTIA certification provider */
  CertificationVoucherProviderType["Comptia"] = "COMPTIA";
  /** Microsoft certification provider */
  CertificationVoucherProviderType["Microsoft"] = "MICROSOFT";
  return CertificationVoucherProviderType;
}({});

/** The state of an individual voucher instance */
export let CertificationVoucherState = /*#__PURE__*/function (CertificationVoucherState) {
  /** The voucher code has been revealed to the user */
  CertificationVoucherState["CodeRevealed"] = "CODE_REVEALED";
  /** The voucher has been purchased */
  CertificationVoucherState["Purchased"] = "PURCHASED";
  /** The voucher is currently reserved */
  CertificationVoucherState["Reserved"] = "RESERVED";
  return CertificationVoucherState;
}({});

/** Possible chat feedback form selections */
export let ChatFeedbackFormSelection = /*#__PURE__*/function (ChatFeedbackFormSelection) {
  /** Chat feedback form selection is not correct */
  ChatFeedbackFormSelection["NotCorrect"] = "NOT_CORRECT";
  /** Chat feedback form selection is helpful */
  ChatFeedbackFormSelection["NotHelpful"] = "NOT_HELPFUL";
  /** Chat feedback form selection is not relevant */
  ChatFeedbackFormSelection["NotRelevant"] = "NOT_RELEVANT";
  /** Chat feedback form selection is offensive */
  ChatFeedbackFormSelection["Offensive"] = "OFFENSIVE";
  /** Chat feedback form selection is unspecified */
  ChatFeedbackFormSelection["Unspecified"] = "UNSPECIFIED";
  return ChatFeedbackFormSelection;
}({});

/** Possible chat feedback options */
export let ChatFeedbackOption = /*#__PURE__*/function (ChatFeedbackOption) {
  /** Chat feedback is negative */
  ChatFeedbackOption["Negative"] = "NEGATIVE";
  /** Chat feedback is positive */
  ChatFeedbackOption["Positive"] = "POSITIVE";
  /** Chat feedback is unspecified */
  ChatFeedbackOption["Unspecified"] = "UNSPECIFIED";
  return ChatFeedbackOption;
}({});

/** Possible chat feedback target types to distinguish where feedback originates from. */
export let ChatFeedbackTargetType = /*#__PURE__*/function (ChatFeedbackTargetType) {
  /** Feedback target is discovery chat */
  ChatFeedbackTargetType["DiscoveryChat"] = "DISCOVERY_CHAT";
  /** Feedback target is in-course chat */
  ChatFeedbackTargetType["InCourseChat"] = "IN_COURSE_CHAT";
  /** Feedback target type is unspecified */
  ChatFeedbackTargetType["Unspecified"] = "UNSPECIFIED";
  return ChatFeedbackTargetType;
}({});

/** The ClosedCaptionLanguageCode scalar type. */
export let ClosedCaptionLanguageCode = /*#__PURE__*/function (ClosedCaptionLanguageCode) {
  /** Afrikaans */
  ClosedCaptionLanguageCode["Af"] = "AF";
  /** Akan */
  ClosedCaptionLanguageCode["Ak"] = "AK";
  /** Amharic */
  ClosedCaptionLanguageCode["Am"] = "AM";
  /** Arabic */
  ClosedCaptionLanguageCode["Ar"] = "AR";
  /** Arabic [CC] */
  ClosedCaptionLanguageCode["ArCc"] = "AR_CC";
  /** Assamese */
  ClosedCaptionLanguageCode["As"] = "AS";
  /** Azerbaijani */
  ClosedCaptionLanguageCode["Az"] = "AZ";
  /** Belarusian */
  ClosedCaptionLanguageCode["Be"] = "BE";
  /** Bulgarian */
  ClosedCaptionLanguageCode["Bg"] = "BG";
  /** Bambara */
  ClosedCaptionLanguageCode["Bm"] = "BM";
  /** Bangla */
  ClosedCaptionLanguageCode["Bn"] = "BN";
  /** Tibetan */
  ClosedCaptionLanguageCode["Bo"] = "BO";
  /** Breton */
  ClosedCaptionLanguageCode["Br"] = "BR";
  /** Bosnian */
  ClosedCaptionLanguageCode["Bs"] = "BS";
  /** Catalan */
  ClosedCaptionLanguageCode["Ca"] = "CA";
  /** Chechen */
  ClosedCaptionLanguageCode["Ce"] = "CE";
  /** Czech */
  ClosedCaptionLanguageCode["Cs"] = "CS";
  /** Church Slavic */
  ClosedCaptionLanguageCode["Cu"] = "CU";
  /** Welsh */
  ClosedCaptionLanguageCode["Cy"] = "CY";
  /** Danish */
  ClosedCaptionLanguageCode["Da"] = "DA";
  /** German */
  ClosedCaptionLanguageCode["De"] = "DE";
  /** German [CC] */
  ClosedCaptionLanguageCode["DeCc"] = "DE_CC";
  /** Dzongkha */
  ClosedCaptionLanguageCode["Dz"] = "DZ";
  /** Ewe */
  ClosedCaptionLanguageCode["Ee"] = "EE";
  /** Greek */
  ClosedCaptionLanguageCode["El"] = "EL";
  /** English */
  ClosedCaptionLanguageCode["En"] = "EN";
  /** English [CC] */
  ClosedCaptionLanguageCode["EnCc"] = "EN_CC";
  /** Esperanto */
  ClosedCaptionLanguageCode["Eo"] = "EO";
  /** Spanish */
  ClosedCaptionLanguageCode["Es"] = "ES";
  /** Spanish [CC] */
  ClosedCaptionLanguageCode["EsCc"] = "ES_CC";
  /** Estonian */
  ClosedCaptionLanguageCode["Et"] = "ET";
  /** Estonian [CC] */
  ClosedCaptionLanguageCode["EtCc"] = "ET_CC";
  /** Basque */
  ClosedCaptionLanguageCode["Eu"] = "EU";
  /** Persian */
  ClosedCaptionLanguageCode["Fa"] = "FA";
  /** Fulah */
  ClosedCaptionLanguageCode["Ff"] = "FF";
  /** Finnish */
  ClosedCaptionLanguageCode["Fi"] = "FI";
  /** Faroese */
  ClosedCaptionLanguageCode["Fo"] = "FO";
  /** French */
  ClosedCaptionLanguageCode["Fr"] = "FR";
  /** French [CC] */
  ClosedCaptionLanguageCode["FrCc"] = "FR_CC";
  /** Western Frisian */
  ClosedCaptionLanguageCode["Fy"] = "FY";
  /** Irish */
  ClosedCaptionLanguageCode["Ga"] = "GA";
  /** Scottish Gaelic */
  ClosedCaptionLanguageCode["Gd"] = "GD";
  /** Galician */
  ClosedCaptionLanguageCode["Gl"] = "GL";
  /** Gujarati */
  ClosedCaptionLanguageCode["Gu"] = "GU";
  /** Manx */
  ClosedCaptionLanguageCode["Gv"] = "GV";
  /** Hausa */
  ClosedCaptionLanguageCode["Ha"] = "HA";
  /** Hebrew */
  ClosedCaptionLanguageCode["He"] = "HE";
  /** Hindi */
  ClosedCaptionLanguageCode["Hi"] = "HI";
  /** Hindi [CC] */
  ClosedCaptionLanguageCode["HiCc"] = "HI_CC";
  /** Croatian */
  ClosedCaptionLanguageCode["Hr"] = "HR";
  /** Hungarian */
  ClosedCaptionLanguageCode["Hu"] = "HU";
  /** Armenian */
  ClosedCaptionLanguageCode["Hy"] = "HY";
  /** Armenian [CC] */
  ClosedCaptionLanguageCode["HyCc"] = "HY_CC";
  /** Interlingua */
  ClosedCaptionLanguageCode["Ia"] = "IA";
  /** Indonesian */
  ClosedCaptionLanguageCode["Id"] = "ID";
  /** Indonesian [CC] */
  ClosedCaptionLanguageCode["IdCc"] = "ID_CC";
  /** Igbo */
  ClosedCaptionLanguageCode["Ig"] = "IG";
  /** Sichuan Yi */
  ClosedCaptionLanguageCode["Ii"] = "II";
  /** Icelandic */
  ClosedCaptionLanguageCode["Is"] = "IS";
  /** Italian */
  ClosedCaptionLanguageCode["It"] = "IT";
  /** Italian [CC] */
  ClosedCaptionLanguageCode["ItCc"] = "IT_CC";
  /** Japanese */
  ClosedCaptionLanguageCode["Ja"] = "JA";
  /** Japanese [CC] */
  ClosedCaptionLanguageCode["JaCc"] = "JA_CC";
  /** Javanese */
  ClosedCaptionLanguageCode["Jv"] = "JV";
  /** Georgian */
  ClosedCaptionLanguageCode["Ka"] = "KA";
  /** Kikuyu */
  ClosedCaptionLanguageCode["Ki"] = "KI";
  /** Kazakh */
  ClosedCaptionLanguageCode["Kk"] = "KK";
  /** Kalaallisut */
  ClosedCaptionLanguageCode["Kl"] = "KL";
  /** Khmer */
  ClosedCaptionLanguageCode["Km"] = "KM";
  /** Kannada */
  ClosedCaptionLanguageCode["Kn"] = "KN";
  /** Korean */
  ClosedCaptionLanguageCode["Ko"] = "KO";
  /** Korean [CC] */
  ClosedCaptionLanguageCode["KoCc"] = "KO_CC";
  /** Kashmiri */
  ClosedCaptionLanguageCode["Ks"] = "KS";
  /** Kurdish */
  ClosedCaptionLanguageCode["Ku"] = "KU";
  /** Cornish */
  ClosedCaptionLanguageCode["Kw"] = "KW";
  /** Kyrgyz */
  ClosedCaptionLanguageCode["Ky"] = "KY";
  /** Luxembourgish */
  ClosedCaptionLanguageCode["Lb"] = "LB";
  /** Ganda */
  ClosedCaptionLanguageCode["Lg"] = "LG";
  /** Lingala */
  ClosedCaptionLanguageCode["Ln"] = "LN";
  /** Lao */
  ClosedCaptionLanguageCode["Lo"] = "LO";
  /** Lithuanian */
  ClosedCaptionLanguageCode["Lt"] = "LT";
  /** Luba-Katanga */
  ClosedCaptionLanguageCode["Lu"] = "LU";
  /** Latvian */
  ClosedCaptionLanguageCode["Lv"] = "LV";
  /** Malagasy */
  ClosedCaptionLanguageCode["Mg"] = "MG";
  /** Māori */
  ClosedCaptionLanguageCode["Mi"] = "MI";
  /** Macedonian */
  ClosedCaptionLanguageCode["Mk"] = "MK";
  /** Malayalam */
  ClosedCaptionLanguageCode["Ml"] = "ML";
  /** Mongolian */
  ClosedCaptionLanguageCode["Mn"] = "MN";
  /** Marathi */
  ClosedCaptionLanguageCode["Mr"] = "MR";
  /** Malay */
  ClosedCaptionLanguageCode["Ms"] = "MS";
  /** Maltese */
  ClosedCaptionLanguageCode["Mt"] = "MT";
  /** Burmese */
  ClosedCaptionLanguageCode["My"] = "MY";
  /** Norwegian (Bokmål) */
  ClosedCaptionLanguageCode["Nb"] = "NB";
  /** North Ndebele */
  ClosedCaptionLanguageCode["Nd"] = "ND";
  /** Nepali */
  ClosedCaptionLanguageCode["Ne"] = "NE";
  /** Dutch */
  ClosedCaptionLanguageCode["Nl"] = "NL";
  /** Dutch [CC] */
  ClosedCaptionLanguageCode["NlCc"] = "NL_CC";
  /** Norwegian Nynorsk */
  ClosedCaptionLanguageCode["Nn"] = "NN";
  /** Norwegian */
  ClosedCaptionLanguageCode["No"] = "NO";
  /** Oromo */
  ClosedCaptionLanguageCode["Om"] = "OM";
  /** Odia */
  ClosedCaptionLanguageCode["Or"] = "OR";
  /** Ossetic */
  ClosedCaptionLanguageCode["Os"] = "OS";
  /** Punjabi */
  ClosedCaptionLanguageCode["Pa"] = "PA";
  /** Polish */
  ClosedCaptionLanguageCode["Pl"] = "PL";
  /** Polish [CC] */
  ClosedCaptionLanguageCode["PlCc"] = "PL_CC";
  /** Pashto */
  ClosedCaptionLanguageCode["Ps"] = "PS";
  /** Portuguese */
  ClosedCaptionLanguageCode["Pt"] = "PT";
  /** Portuguese (Brazil) */
  ClosedCaptionLanguageCode["PtBr"] = "PT_BR";
  /** Portuguese [CC] */
  ClosedCaptionLanguageCode["PtCc"] = "PT_CC";
  /** Portuguese (Portugal) */
  ClosedCaptionLanguageCode["PtPt"] = "PT_PT";
  /** Quechua */
  ClosedCaptionLanguageCode["Qu"] = "QU";
  /** Romansh */
  ClosedCaptionLanguageCode["Rm"] = "RM";
  /** Rundi */
  ClosedCaptionLanguageCode["Rn"] = "RN";
  /** Romanian */
  ClosedCaptionLanguageCode["Ro"] = "RO";
  /** Russian */
  ClosedCaptionLanguageCode["Ru"] = "RU";
  /** Russian [CC] */
  ClosedCaptionLanguageCode["RuCc"] = "RU_CC";
  /** Kinyarwanda */
  ClosedCaptionLanguageCode["Rw"] = "RW";
  /** Sindhi */
  ClosedCaptionLanguageCode["Sd"] = "SD";
  /** Northern Sami */
  ClosedCaptionLanguageCode["Se"] = "SE";
  /** Sango */
  ClosedCaptionLanguageCode["Sg"] = "SG";
  /** Sinhala */
  ClosedCaptionLanguageCode["Si"] = "SI";
  /** Slovak */
  ClosedCaptionLanguageCode["Sk"] = "SK";
  /** Slovenian */
  ClosedCaptionLanguageCode["Sl"] = "SL";
  /** Shona */
  ClosedCaptionLanguageCode["Sn"] = "SN";
  /** Somali */
  ClosedCaptionLanguageCode["So"] = "SO";
  /** Albanian */
  ClosedCaptionLanguageCode["Sq"] = "SQ";
  /** Serbian */
  ClosedCaptionLanguageCode["Sr"] = "SR";
  /** Sundanese */
  ClosedCaptionLanguageCode["Su"] = "SU";
  /** Swedish */
  ClosedCaptionLanguageCode["Sv"] = "SV";
  /** Swahili */
  ClosedCaptionLanguageCode["Sw"] = "SW";
  /** Tamil */
  ClosedCaptionLanguageCode["Ta"] = "TA";
  /** Tamil [CC] */
  ClosedCaptionLanguageCode["TaCc"] = "TA_CC";
  /** Telugu */
  ClosedCaptionLanguageCode["Te"] = "TE";
  /** Tajik */
  ClosedCaptionLanguageCode["Tg"] = "TG";
  /** Thai */
  ClosedCaptionLanguageCode["Th"] = "TH";
  /** Thai [CC] */
  ClosedCaptionLanguageCode["ThCc"] = "TH_CC";
  /** Tigrinya */
  ClosedCaptionLanguageCode["Ti"] = "TI";
  /** Turkmen */
  ClosedCaptionLanguageCode["Tk"] = "TK";
  /** Tongan */
  ClosedCaptionLanguageCode["To"] = "TO";
  /** Turkish */
  ClosedCaptionLanguageCode["Tr"] = "TR";
  /** Turkish [CC] */
  ClosedCaptionLanguageCode["TrCc"] = "TR_CC";
  /** Tatar */
  ClosedCaptionLanguageCode["Tt"] = "TT";
  /** Uyghur */
  ClosedCaptionLanguageCode["Ug"] = "UG";
  /** Ukrainian */
  ClosedCaptionLanguageCode["Uk"] = "UK";
  /** Ukrainian [CC] */
  ClosedCaptionLanguageCode["UkCc"] = "UK_CC";
  /** Urdu */
  ClosedCaptionLanguageCode["Ur"] = "UR";
  /** Uzbek */
  ClosedCaptionLanguageCode["Uz"] = "UZ";
  /** Vietnamese */
  ClosedCaptionLanguageCode["Vi"] = "VI";
  /** Vietnamese [CC] */
  ClosedCaptionLanguageCode["ViCc"] = "VI_CC";
  /** Volapük */
  ClosedCaptionLanguageCode["Vo"] = "VO";
  /** Wolof */
  ClosedCaptionLanguageCode["Wo"] = "WO";
  /** Xhosa */
  ClosedCaptionLanguageCode["Xh"] = "XH";
  /** Yiddish */
  ClosedCaptionLanguageCode["Yi"] = "YI";
  /** Yoruba */
  ClosedCaptionLanguageCode["Yo"] = "YO";
  /** Chinese */
  ClosedCaptionLanguageCode["Zh"] = "ZH";
  /** Chinese [CC] */
  ClosedCaptionLanguageCode["ZhCc"] = "ZH_CC";
  /** Chinese (Simplified) */
  ClosedCaptionLanguageCode["ZhCn"] = "ZH_CN";
  /** Chinese (Traditional) */
  ClosedCaptionLanguageCode["ZhTw"] = "ZH_TW";
  /** Zulu */
  ClosedCaptionLanguageCode["Zu"] = "ZU";
  return ClosedCaptionLanguageCode;
}({});

/** A lab instance running on a cloud provider (AWS, Azure, or GCP). Users are provided temporary credentials to access the cloud environment */

/** Polymorphic credentials type that resolves to provider-specific credential fields based on the cloud provider */

/** Supported cloud providers for hosting lab instances */
export let CloudLabInstanceProvider = /*#__PURE__*/function (CloudLabInstanceProvider) {
  /** Amazon Web Services */
  CloudLabInstanceProvider["Aws"] = "AWS";
  /** Microsoft Azure */
  CloudLabInstanceProvider["Azure"] = "AZURE";
  /** Google Cloud Platform */
  CloudLabInstanceProvider["Gcp"] = "GCP";
  return CloudLabInstanceProvider;
}({});

/** A micro-content representing a code block */

/** Type of the files withing coding exercise templates */

/** Coding exercise for students to practice their programming */

/** Language possibilities for a coding exercise */
export let CodingExerciseLanguageOption = /*#__PURE__*/function (CodingExerciseLanguageOption) {
  /** C++ 14 */
  CodingExerciseLanguageOption["Cplusplus"] = "CPLUSPLUS";
  /** C++ 20 */
  CodingExerciseLanguageOption["Cplusplus_20"] = "CPLUSPLUS_20";
  /** CSV processing with Python */
  CodingExerciseLanguageOption["CsvProcessingWithPython"] = "CSV_PROCESSING_WITH_PYTHON";
  /** C# */
  CodingExerciseLanguageOption["CSharp"] = "C_SHARP";
  /** C# 11 */
  CodingExerciseLanguageOption["CSharp_11"] = "C_SHARP_11";
  /** HTML */
  CodingExerciseLanguageOption["Html"] = "HTML";
  /** JavaScript ES6 */
  CodingExerciseLanguageOption["JavascriptEs6"] = "JAVASCRIPT_ES6";
  /** Java 9 */
  CodingExerciseLanguageOption["Java_9"] = "JAVA_9";
  /** Java 11 */
  CodingExerciseLanguageOption["Java_11"] = "JAVA_11";
  /** Java 17 */
  CodingExerciseLanguageOption["Java_17"] = "JAVA_17";
  /** Java 21 */
  CodingExerciseLanguageOption["Java_21"] = "JAVA_21";
  /** Kotlin 1.9 */
  CodingExerciseLanguageOption["Kotlin_1_9"] = "KOTLIN_1_9";
  /** PHP 5 */
  CodingExerciseLanguageOption["Php_5"] = "PHP_5";
  /** PHP 7 */
  CodingExerciseLanguageOption["Php_7"] = "PHP_7";
  /** Python 3.5 */
  CodingExerciseLanguageOption["Python_3_5"] = "PYTHON_3_5";
  /** Python 3.8 */
  CodingExerciseLanguageOption["Python_3_8"] = "PYTHON_3_8";
  /** Python 3.10 */
  CodingExerciseLanguageOption["Python_3_10"] = "PYTHON_3_10";
  /** React 16 */
  CodingExerciseLanguageOption["React_16"] = "REACT_16";
  /** React 18 */
  CodingExerciseLanguageOption["React_18"] = "REACT_18";
  /** Ruby */
  CodingExerciseLanguageOption["Ruby"] = "RUBY";
  /** R 3.6 */
  CodingExerciseLanguageOption["R_3_6"] = "R_3_6";
  /** SciPy 1.4 (Numby, Pandas, SymPy and SkiCit Learn 0.23 */
  CodingExerciseLanguageOption["Scipy_1_4NumpyPandasSympyAndScikitLearn_0_23"] = "SCIPY_1_4_NUMPY_PANDAS_SYMPY_AND_SCIKIT_LEARN_0_23";
  /** SQL (MySQL) */
  CodingExerciseLanguageOption["Sql"] = "SQL";
  /** SQLITE 3 */
  CodingExerciseLanguageOption["Sqlite_3"] = "SQLITE_3";
  /** Swift 3 */
  CodingExerciseLanguageOption["Swift_3"] = "SWIFT_3";
  /** Swift 5 */
  CodingExerciseLanguageOption["Swift_5"] = "SWIFT_5";
  /** Web Development */
  CodingExerciseLanguageOption["WebDevelopment"] = "WEB_DEVELOPMENT";
  return CodingExerciseLanguageOption;
}({});

/** A wrapper type to include the recommended Coding Exercise and some additional fields about its recommendation */

/** Type of the coding exercise templates */

/** Filtration options for the coding exercise templates */

/** A lab instance running on docker container-based infrastructure */

/** Type representing a group of content for a subscription plan */

/** Stats related to the items in a content collection */

/** Source of a lesson component */
export let ContentSourceType = /*#__PURE__*/function (ContentSourceType) {
  /** The source is the AI */
  ContentSourceType["Ai"] = "AI";
  /** The source is the instructor */
  ContentSourceType["Instructor"] = "INSTRUCTOR";
  /** The source is mixed */
  ContentSourceType["Mixed"] = "MIXED";
  return ContentSourceType;
}({});

/** The Course object. */

/** The Course object. */

/** Accreditations */

/** Accreditation types */
export let CourseAccreditationType = /*#__PURE__*/function (CourseAccreditationType) {
  /** Continuing professional education */
  CourseAccreditationType["Cpe"] = "CPE";
  return CourseAccreditationType;
}({});

/** AI generated highlights for a course */

/** Course caption details such as locale, type, and source */

/** A catalog of all courses available to the client */

/** Changes to catalog of all courses available to the client */

/** Category the Course belongs to */

/** Course collection specific properties */

/** Request to copy a course with specified task arguments */

/** Response type for course copy request creation */

/** Asynchronous task for copying a course */

/** Status of a course copy task */
export let CourseCopyTaskStatus = /*#__PURE__*/function (CourseCopyTaskStatus) {
  /** The course copy request or task has failed */
  CourseCopyTaskStatus["Failed"] = "FAILED";
  /** The course copy request or task is in progress */
  CourseCopyTaskStatus["InProgress"] = "IN_PROGRESS";
  /** The course copy request or task is created */
  CourseCopyTaskStatus["Pending"] = "PENDING";
  /** The course copy request or task has been completed successfully */
  CourseCopyTaskStatus["Success"] = "SUCCESS";
  return CourseCopyTaskStatus;
}({});

/** Count of the course curriculum content by type */

/** Course enrollment */

/** Enrollments belonging to the course */

/** Filters for course enrollments */

/** Paged course enrollments */

/** Sort order options for course enrollments */

/** Course images by varying dimensions */

/** Instructor for a course */

/** Input for linking an opportunity to a course */

/** Organization specific course properties */

/** Object to store URL and expiration time for course's promo video */

/** Ratings of a course */

/** A wrapper type to include the recommended Course and some additional fields about its recommendation */

/** Additional search context for specific UX cases */

/** Search filters to apply on search request */

/** List of Courses and additional data about search response */

/** Contains info for front end related stuff and tracking info. This data is calculated by backend service and used by Udemy front end. If you are an external user, you shouldn't need this. */

/** Represents a course search result with additional data about the search response. */

/** Sort order for courses in search response */
export let CourseSearchSortType = /*#__PURE__*/function (CourseSearchSortType) {
  /** Highest rated */
  CourseSearchSortType["Rating"] = "RATING";
  /** Most relevant */
  CourseSearchSortType["Relevance"] = "RELEVANCE";
  /** Most reviewed */
  CourseSearchSortType["Reviews"] = "REVIEWS";
  /** Newest */
  CourseSearchSortType["Time"] = "TIME";
  return CourseSearchSortType;
}({});

/** Trigger types for the course search. */
export let CourseSearchTriggerType = /*#__PURE__*/function (CourseSearchTriggerType) {
  /** Course search triggered by the Amazon Alexa app */
  CourseSearchTriggerType["AlexaApp"] = "ALEXA_APP";
  /** Course search triggered by a category page (e.g, https://www.udemy.com/courses/development/) */
  CourseSearchTriggerType["BrowseCategory"] = "BROWSE_CATEGORY";
  /**
   * Course search triggered by a browse certification page
   * This includes pages like:
   * - https://www.udemy.com/browse/certification/
   * - https://www.udemy.com/browse/certification/... (e.g., https://www.udemy.com/browse/certification/aws-certifications/)
   */
  CourseSearchTriggerType["BrowseCertification"] = "BROWSE_CERTIFICATION";
  /** Course search triggered by an elevate landing page */
  CourseSearchTriggerType["BrowseElevate"] = "BROWSE_ELEVATE";
  /** Course search triggered by a roleplay browse page (e.g, https://www.udemy.com/ai-roleplay/) */
  CourseSearchTriggerType["BrowseRoleplay"] = "BROWSE_ROLEPLAY";
  /** Course search triggered by a subcategory page (e.g, https://www.udemy.com/courses/development/web-development/) */
  CourseSearchTriggerType["BrowseSubcategory"] = "BROWSE_SUBCATEGORY";
  /** Course search triggered by a topic page (e.g, https://www.udemy.com/topic/machine-learning/) */
  CourseSearchTriggerType["BrowseTopic"] = "BROWSE_TOPIC";
  /** Course search triggered by the ChatGPT app */
  CourseSearchTriggerType["ChatgptApp"] = "CHATGPT_APP";
  /** Course search triggered by the MCP server */
  CourseSearchTriggerType["McpServer"] = "MCP_SERVER";
  /** User clicks on a narrowing search suggestion */
  CourseSearchTriggerType["NarrowingSearch"] = "NARROWING_SEARCH";
  /** User clicks on recommendation unit */
  CourseSearchTriggerType["Recommendation"] = "RECOMMENDATION";
  /** User clicks on related searches suggestion */
  CourseSearchTriggerType["RelatedSearches"] = "RELATED_SEARCHES";
  /** User selects a search autocomplete */
  CourseSearchTriggerType["SearchAutocomplete"] = "SEARCH_AUTOCOMPLETE";
  /** User insists on the original query, exactly as typed */
  CourseSearchTriggerType["SearchOriginalQuery"] = "SEARCH_ORIGINAL_QUERY";
  /** User selects a search suggested query */
  CourseSearchTriggerType["SearchQuerySuggestion"] = "SEARCH_QUERY_SUGGESTION";
  /** Course search triggered by native mobile apps for initial zero-state suggested search terms */
  CourseSearchTriggerType["SearchTrendingQuery"] = "SEARCH_TRENDING_QUERY";
  /** Course search triggered by Android native app for top/trending search queries */
  CourseSearchTriggerType["TopSearches"] = "TOP_SEARCHES";
  /** User inputs query in the search bar */
  CourseSearchTriggerType["UserQuery"] = "USER_QUERY";
  return CourseSearchTriggerType;
}({});

/** Section of the course containing all types of curriculum items */

/** A wrapper type to include the recommended Course Section and some additional fields about its recommendation */

/** Response for create snapshot */

/** SubCategory that is part of CourseCategory */

/** Subscription specific course properties */

/** Course taking-related organization settings */

/** Course Variant that belongs to a Course Variation */

/** Course variant that belongs to a Course Variation */

/** A variation of courses */

/** Aggregation of Course Variations */

/** Response for update/create */

/** Reponse for deletion */

/** Input for Course Variation Aggregation */

/** Input for each Course Variation */

/** Option in a Course Variation */

/** Option in a Course Variation */

/** Types of variations */
export let CourseVariationType = /*#__PURE__*/function (CourseVariationType) {
  /** Audience */
  CourseVariationType["Audience"] = "AUDIENCE";
  /** Course Edition */
  CourseVariationType["CourseEdition"] = "COURSE_EDITION";
  /** Language */
  CourseVariationType["Language"] = "LANGUAGE";
  /** Topic */
  CourseVariationType["Topic"] = "TOPIC";
  return CourseVariationType;
}({});

/** Currencies available */
export let CurrencyCode = /*#__PURE__*/function (CurrencyCode) {
  /** Australian dollar */
  CurrencyCode["Aud"] = "AUD";
  /** Brazilian real */
  CurrencyCode["Brl"] = "BRL";
  /** Canadian dollar */
  CurrencyCode["Cad"] = "CAD";
  /** Chilean peso */
  CurrencyCode["Clp"] = "CLP";
  /** Colombian peso */
  CurrencyCode["Cop"] = "COP";
  /** Danish crone */
  CurrencyCode["Dkk"] = "DKK";
  /** Egyptian pound */
  CurrencyCode["Egp"] = "EGP";
  /** Euro */
  CurrencyCode["Eur"] = "EUR";
  /** Sterling */
  CurrencyCode["Gbp"] = "GBP";
  /** Indonesian rupiah */
  CurrencyCode["Idr"] = "IDR";
  /** Israel new shekel */
  CurrencyCode["Ils"] = "ILS";
  /** Indian rupee */
  CurrencyCode["Inr"] = "INR";
  /** Japanese yen */
  CurrencyCode["Jpy"] = "JPY";
  /** South Korean won */
  CurrencyCode["Krw"] = "KRW";
  /** Mexican peso */
  CurrencyCode["Mxn"] = "MXN";
  /** Malaysian ringgit */
  CurrencyCode["Myr"] = "MYR";
  /** Nigerian naira */
  CurrencyCode["Ngn"] = "NGN";
  /** Norwegian krone */
  CurrencyCode["Nok"] = "NOK";
  /** Peruvian sol */
  CurrencyCode["Pen"] = "PEN";
  /** Philippine peso */
  CurrencyCode["Php"] = "PHP";
  /** Polish złoty */
  CurrencyCode["Pln"] = "PLN";
  /** Romanian leu */
  CurrencyCode["Ron"] = "RON";
  /** Russian ruble */
  CurrencyCode["Rub"] = "RUB";
  /** Singapore dollar */
  CurrencyCode["Sgd"] = "SGD";
  /** Thai baht */
  CurrencyCode["Thb"] = "THB";
  /** Turkish lira */
  CurrencyCode["Try"] = "TRY";
  /** New Taiwan dollar */
  CurrencyCode["Twd"] = "TWD";
  /** United States dollar */
  CurrencyCode["Usd"] = "USD";
  /** Vietnamese dong */
  CurrencyCode["Vnd"] = "VND";
  /** South African rand */
  CurrencyCode["Zar"] = "ZAR";
  return CurrencyCode;
}({});

/** Curriculum part of a course */

/** Interface for a curriculum item */

/** Input for cursor-based pagination queries. Used to request a specific page of results. */

/** Interface for implementing cursor-based pagination responses. */

/**
 * If a part of the response needs customizations about how it should be rendered on the UI, this interface should be
 * implemented.
 */

/** Price option for computed price plan. Will be returned for daily plans */

/** Represents the type of data transfer */
export let DataTransferType = /*#__PURE__*/function (DataTransferType) {
  /** Presigned url file transfer */
  DataTransferType["PresignedUrl"] = "PRESIGNED_URL";
  /** Pusher transfer */
  DataTransferType["Pusher"] = "PUSHER";
  return DataTransferType;
}({});

/** Filter used to pass start and end date between which learning activity has to be returned. Date range should be less than or equal to 120 days when granularity is DAY level. */

/** Type representing details about an interval of dates */

/** Supported units of time over which a subscription trial or billing cycle can occur */
export let DateIntervalType = /*#__PURE__*/function (DateIntervalType) {
  /** Daily interval */
  DateIntervalType["Day"] = "DAY";
  /** Monthly interval */
  DateIntervalType["Month"] = "MONTH";
  /** Weekly interval */
  DateIntervalType["Week"] = "WEEK";
  /** Yearly interval */
  DateIntervalType["Year"] = "YEAR";
  return DateIntervalType;
}({});

/** An input that accepts a range of dates to filter the data. If the end date is not provided, it will be considered as now. The dates are inclusive */

/** Day of the week for report scheduling */
export let DayOfWeek = /*#__PURE__*/function (DayOfWeek) {
  /** Friday */
  DayOfWeek["Friday"] = "FRIDAY";
  /** Monday */
  DayOfWeek["Monday"] = "MONDAY";
  /** Saturday */
  DayOfWeek["Saturday"] = "SATURDAY";
  /** Sunday */
  DayOfWeek["Sunday"] = "SUNDAY";
  /** Thursday */
  DayOfWeek["Thursday"] = "THURSDAY";
  /** Tuesday */
  DayOfWeek["Tuesday"] = "TUESDAY";
  /** Wednesday */
  DayOfWeek["Wednesday"] = "WEDNESDAY";
  return DayOfWeek;
}({});

/** Instruction level of the course */
export let DifficultyLevel = /*#__PURE__*/function (DifficultyLevel) {
  /** Item is appropriate for all skill levels */
  DifficultyLevel["AllLevels"] = "ALL_LEVELS";
  /** Item is for beginners */
  DifficultyLevel["Beginner"] = "BEGINNER";
  /** Item is for students with expert knowledge */
  DifficultyLevel["Expert"] = "EXPERT";
  /** Item is for students with intermediates knowledge */
  DifficultyLevel["Intermediate"] = "INTERMEDIATE";
  return DifficultyLevel;
}({});

/** definition of different discount source types */
export let DiscountSourceType = /*#__PURE__*/function (DiscountSourceType) {
  /** General discount coupon code */
  DiscountSourceType["GeneralCoupon"] = "GENERAL_COUPON";
  /** Instructor discount coupon code */
  DiscountSourceType["InstructorCoupon"] = "INSTRUCTOR_COUPON";
  /** Udemy discount coupon code */
  DiscountSourceType["UdemyCoupon"] = "UDEMY_COUPON";
  return DiscountSourceType;
}({});

/** The content of a component defined in the CMS */

/** The dynamic web content query filter options */

/** The dynamic web image object. This combines the image URL and the alt text for the image for a11y purposes. */

/** The specific page type for the dynamic web content. This is important for narrowing down the content in the CMS to where Marketing wants to render it. */
export let DynamicWebContentPageType = /*#__PURE__*/function (DynamicWebContentPageType) {
  /** Logged out home page of udemy */
  DynamicWebContentPageType["LoggedOutHomePage"] = "LOGGED_OUT_HOME_PAGE";
  /** Personal Plan Landing page */
  DynamicWebContentPageType["PersonalPlanLandingPage"] = "PERSONAL_PLAN_LANDING_PAGE";
  /** Udemy Business request demo form */
  DynamicWebContentPageType["RequestDemoForm"] = "REQUEST_DEMO_FORM";
  return DynamicWebContentPageType;
}({});

/** Lecture in form of an EBook (deprecated) */

/** Lecture in form of an EBook (deprecated) */

/** A record of user's enrollment to a learning product */

/** Response object for archiving an enrollment. */

/** Response object for enrollment creation */

/** Source of the enrollment */
export let EnrollmentSourceType = /*#__PURE__*/function (EnrollmentSourceType) {
  /** The enrollment was created from a purchase */
  EnrollmentSourceType["Purchase"] = "PURCHASE";
  /** The enrollment was created from a subscription context */
  EnrollmentSourceType["Subscription"] = "SUBSCRIPTION";
  return EnrollmentSourceType;
}({});

/** Response object for unarchiving an enrollment. */

/** Input for enrolling to learning product */

/** Learning product type input */
export let EnrollmentsLearningProductInputType = /*#__PURE__*/function (EnrollmentsLearningProductInputType) {
  /** Badge Class */
  EnrollmentsLearningProductInputType["BadgeClass"] = "BADGE_CLASS";
  /** Career Accelerator */
  EnrollmentsLearningProductInputType["CareerAccelerator"] = "CAREER_ACCELERATOR";
  /** Course */
  EnrollmentsLearningProductInputType["Course"] = "COURSE";
  return EnrollmentsLearningProductInputType;
}({});

/** Represents the entity who was affected by the event. */

/** Defines the type of entity who was affected by the event. */
export let EntityType = /*#__PURE__*/function (EntityType) {
  /** Represents an end user who was affected by the action. */
  EntityType["EndUser"] = "END_USER";
  /** Represents a group which was affected by the action. */
  EntityType["Group"] = "GROUP";
  /** Represents a license which was affected by the action. */
  EntityType["License"] = "LICENSE";
  /** Means the entity type is not applicable for this event. */
  EntityType["Na"] = "NA";
  return EntityType;
}({});

/** Lecture that refers to an external source (deprecated) */

/** Lecture that refers to an external source (deprecated) */

/** Stores realtime attribute like build_number->20220322_v1 */

/** Holds assigned feature variant  */

/** Holds filters for feature variant assignments */

/** Feedback object */

/** Input to create Feedback */

/** Response for storing a feedback */

/** Polymorphic object to represent what the feedback is being applied to */

/** Possible feedback options */
export let FeedbackOption = /*#__PURE__*/function (FeedbackOption) {
  /** Negative feedback is given to a target */
  FeedbackOption["Negative"] = "NEGATIVE";
  /** Positive feedback is given to a target */
  FeedbackOption["Positive"] = "POSITIVE";
  /** Feedback to a target is unselected, or removed */
  FeedbackOption["Unselected"] = "UNSELECTED";
  return FeedbackOption;
}({});

/** Possible object targets to apply the feedback to */
export let FeedbackTargetType = /*#__PURE__*/function (FeedbackTargetType) {
  /** Feedback is given to a course section */
  FeedbackTargetType["CourseSection"] = "COURSE_SECTION";
  /** Feedback is given to a content discovery learning assistant chat message */
  FeedbackTargetType["DiscoveryChat"] = "DISCOVERY_CHAT";
  /** Feedback is given to an in course learning assistant chat message */
  FeedbackTargetType["InCourseChat"] = "IN_COURSE_CHAT";
  /** Feedback is given to an in-course lab */
  FeedbackTargetType["InCourseLab"] = "IN_COURSE_LAB";
  /** Feedback is given to a learning assistant chat message (deprecated) */
  FeedbackTargetType["LearningAssistantChatMessage"] = "LEARNING_ASSISTANT_CHAT_MESSAGE";
  /** Feedback is given to a lecture */
  FeedbackTargetType["Lecture"] = "LECTURE";
  return FeedbackTargetType;
}({});

/** Lecture in the form of a single file (deprecated) */

/** Lecture in the form of a single file (deprecated) */

/** Fill in the blanks question. No options, question text has placeholders for user to fill in */

/** Authentication credentials for accessing a GCP cloud lab instance */

/** Represents types of hands-on learning experiences available in a course. These ribbons indicate interactive learning features that enhance the course experience. */
export let HandsOnRibbonType = /*#__PURE__*/function (HandsOnRibbonType) {
  /** Coding exercise challenges */
  HandsOnRibbonType["CodingExercises"] = "CODING_EXERCISES";
  /** General hands-on practice activities */
  HandsOnRibbonType["HandsOnPractices"] = "HANDS_ON_PRACTICES";
  /** Hands-on lab environments */
  HandsOnRibbonType["Labs"] = "LABS";
  /** Practice test assessments */
  HandsOnRibbonType["PracticeTests"] = "PRACTICE_TESTS";
  /** Quiz assessments */
  HandsOnRibbonType["Quiz"] = "QUIZ";
  /** Interactive role-play exercises */
  HandsOnRibbonType["RolePlay"] = "ROLE_PLAY";
  /** Interactive workspace environments */
  HandsOnRibbonType["Workspace"] = "WORKSPACE";
  return HandsOnRibbonType;
}({});

/** Represents a badge awarded to a hot and new learning product. */

/** Instructor for a learning product */

/** Instructor's account balance */

/** Instructor's account issues */

/** Instructor Content Opportunity object  */

/** Display rule of the content opportunity */
export let InstructorContentOpportunityDisplayRule = /*#__PURE__*/function (InstructorContentOpportunityDisplayRule) {
  /** Opportunity is for all instructors */
  InstructorContentOpportunityDisplayRule["AllInstructors"] = "ALL_INSTRUCTORS";
  /** Opportunity is excluded */
  InstructorContentOpportunityDisplayRule["Exclude"] = "EXCLUDE";
  /** Opportunity is for internal use only */
  InstructorContentOpportunityDisplayRule["InternalOnly"] = "INTERNAL_ONLY";
  /** Opportunity is for IP instructors only */
  InstructorContentOpportunityDisplayRule["IpOnly"] = "IP_ONLY";
  /** Opportunity is no longer a priority */
  InstructorContentOpportunityDisplayRule["NoLongerAPriority"] = "NO_LONGER_A_PRIORITY";
  return InstructorContentOpportunityDisplayRule;
}({});

/** Filters for ContentOpportunity */

/** Level of the content opportunity */
export let InstructorContentOpportunityLevel = /*#__PURE__*/function (InstructorContentOpportunityLevel) {
  /** Opportunity is for all levels */
  InstructorContentOpportunityLevel["AllLevels"] = "ALL_LEVELS";
  /** Opportunity is for any level (any of the above levels) */
  InstructorContentOpportunityLevel["AnyLevel"] = "ANY_LEVEL";
  /** Opportunity is for beginner level */
  InstructorContentOpportunityLevel["Beginner"] = "BEGINNER";
  /** Opportunity is for expert level */
  InstructorContentOpportunityLevel["Expert"] = "EXPERT";
  /** Opportunity is for intermediate level */
  InstructorContentOpportunityLevel["Intermediate"] = "INTERMEDIATE";
  return InstructorContentOpportunityLevel;
}({});

/** Response for creating a course opportunity mapping (Linking an opportunity to a course) */

/** Priority level of the content opportunity */
export let InstructorContentOpportunityPriority = /*#__PURE__*/function (InstructorContentOpportunityPriority) {
  /** High priority */
  InstructorContentOpportunityPriority["High"] = "HIGH";
  /** Low priority */
  InstructorContentOpportunityPriority["Low"] = "LOW";
  /** Medium priority */
  InstructorContentOpportunityPriority["Medium"] = "MEDIUM";
  return InstructorContentOpportunityPriority;
}({});

/** Paginated response for content opportunity search */

/** Sort order for ContentOpportunities */
export let InstructorContentOpportunitySortType = /*#__PURE__*/function (InstructorContentOpportunitySortType) {
  /** Most important */
  InstructorContentOpportunitySortType["Priority"] = "PRIORITY";
  /** Newest */
  InstructorContentOpportunitySortType["Time"] = "TIME";
  return InstructorContentOpportunitySortType;
}({});

/** Type of the content opportunity */
export let InstructorContentOpportunityType = /*#__PURE__*/function (InstructorContentOpportunityType) {
  /** Opportunity is a first mover (there is limited content coverage in UB for the demand) */
  InstructorContentOpportunityType["FirstMover"] = "FIRST_MOVER";
  /** Opportunity is a organization request */
  InstructorContentOpportunityType["OrgRequest"] = "ORG_REQUEST";
  /** Opportunity is a specialized one (demand is high for specific roles) */
  InstructorContentOpportunityType["Specialized"] = "SPECIALIZED";
  /** Opportunity is a trend (there is some content coverage in UB for the demand) */
  InstructorContentOpportunityType["Trending"] = "TRENDING";
  return InstructorContentOpportunityType;
}({});

/** Response for deleting a course opportunity mapping (Unlinking an opportunity from a course) */

/** Instructor images by varying dimensions */

/** Represent learner metrics. Every learner metric has a value and total learner */

/** A representation of a practice-test for instructor insights */

/** Metrics of a Practice Test */

/** A representation of a practice-test question for instructor insights */

/** Choice of a question inside a practice test */

/** Type of an incorrect answer at the Practice Test. */
export let InstructorInsightPracticeTestQuestionChoiceIncorrectType = /*#__PURE__*/function (InstructorInsightPracticeTestQuestionChoiceIncorrectType) {
  /** To mark commonly selected incorrect answer */
  InstructorInsightPracticeTestQuestionChoiceIncorrectType["CommonlySelected"] = "COMMONLY_SELECTED";
  return InstructorInsightPracticeTestQuestionChoiceIncorrectType;
}({});

/** Insight metrics of an answer */

/** Insight metrics of a question inside a practice test */

/** Type of the quality level of a Practice Test Question. */
export let InstructorInsightPracticeTestQuestionQualityLevel = /*#__PURE__*/function (InstructorInsightPracticeTestQuestionQualityLevel) {
  /** The question is bad quality */
  InstructorInsightPracticeTestQuestionQualityLevel["Bad"] = "BAD";
  /** The question is good quality */
  InstructorInsightPracticeTestQuestionQualityLevel["Good"] = "GOOD";
  /** The question is medium quality */
  InstructorInsightPracticeTestQuestionQualityLevel["Medium"] = "MEDIUM";
  /** There is not enough data to determine the quality of the question */
  InstructorInsightPracticeTestQuestionQualityLevel["NotEnoughData"] = "NOT_ENOUGH_DATA";
  return InstructorInsightPracticeTestQuestionQualityLevel;
}({});

/** Status of a question of a Practice Test at a date */
export let InstructorInsightPracticeTestQuestionStatus = /*#__PURE__*/function (InstructorInsightPracticeTestQuestionStatus) {
  /** ACTIVE means the question was/is active */
  InstructorInsightPracticeTestQuestionStatus["Active"] = "ACTIVE";
  /** DELETED means the question was/is deleted */
  InstructorInsightPracticeTestQuestionStatus["Deleted"] = "DELETED";
  return InstructorInsightPracticeTestQuestionStatus;
}({});

/** Type of a question at the Practice Test. It can be multiple choice, multiple selection or fill in the blanks. */
export let InstructorInsightPracticeTestQuestionType = /*#__PURE__*/function (InstructorInsightPracticeTestQuestionType) {
  /** Fill in the blanks question */
  InstructorInsightPracticeTestQuestionType["FillInTheBlanks"] = "FILL_IN_THE_BLANKS";
  /** Multiple choice question */
  InstructorInsightPracticeTestQuestionType["MultipleChoice"] = "MULTIPLE_CHOICE";
  /** Multiple selection question */
  InstructorInsightPracticeTestQuestionType["MultipleSelection"] = "MULTIPLE_SELECTION";
  return InstructorInsightPracticeTestQuestionType;
}({});

/** Practice test version data */

/** Instructor's payout */

/** Instructor's payouts paged */

/** A wrapper type to include the recommended Instructor and some additional fields about its recommendation */

/** The Lab object. */

/** Represents lab context for chat */

/** An instance of a lab's workspace for the user to interact with */

/** The operational state of a lab instance */
export let LabInstanceStatus = /*#__PURE__*/function (LabInstanceStatus) {
  /** Same as killed; action started by an admin(via Tapen, cli script) */
  LabInstanceStatus["AdminKilled"] = "ADMIN_KILLED";
  /** Same as killing; action started by an admin (via Tapen, cli script) */
  LabInstanceStatus["AdminKilling"] = "ADMIN_KILLING";
  /** Similar to killed; used as a signal to a stopped Vocareum lab due to lack of resources */
  LabInstanceStatus["Deactivated"] = "DEACTIVATED";
  /** LabInstance is not working; might be recoverable */
  LabInstanceStatus["Error"] = "ERROR";
  /** LabInstance is being isolated to support the isolation mode */
  LabInstanceStatus["Isolating"] = "ISOLATING";
  /** For some reason, e.g. abuse of resources, the instance was killed */
  LabInstanceStatus["Killed"] = "KILLED";
  /** Someone requested the LabInstance be killed; the instance cannot be started again */
  LabInstanceStatus["Killing"] = "KILLING";
  /** Default state; the LabInstance was created but no call to provision it has been issued yet */
  LabInstanceStatus["Pending"] = "PENDING";
  /** A request to provision the LabInstance was queued with the provider */
  LabInstanceStatus["Queued"] = "QUEUED";
  /** LabInstance is up and running; user can interact with it */
  LabInstanceStatus["Running"] = "RUNNING";
  /** Provider has acknowledged the provisioning request and it's working on it */
  LabInstanceStatus["Starting"] = "STARTING";
  /** LabInstance is not reachable/interactable, but it can be started again */
  LabInstanceStatus["Stopped"] = "STOPPED";
  /** Someone requested the LabInstance be stopped */
  LabInstanceStatus["Stopping"] = "STOPPING";
  return LabInstanceStatus;
}({});

/** Instructor for a lab */

/** MetaData for a lab */

/** Limits established for learners to constrain lab consumption */

/** Quota usage is determined by discrete integer values */

/** Rolling window of time to include user interactions with labs */
export let LabQuotaTimespanType = /*#__PURE__*/function (LabQuotaTimespanType) {
  /** Quota is determined by weekly interactions */
  LabQuotaTimespanType["Week"] = "WEEK";
  return LabQuotaTimespanType;
}({});

/** Entity used for calculating user quotas */
export let LabQuotaType = /*#__PURE__*/function (LabQuotaType) {
  /** Quota has a maximum amount of seconds for lab consumption */
  LabQuotaType["SecondsConsumed"] = "SECONDS_CONSUMED";
  return LabQuotaType;
}({});

/** Specifies how a quota usage is represented */

/** A wrapper type to include the recommended Lab and some additional fields about its recommendation */

/** List of Labs and additional data about search response */

/** Messages administered internally at Udemy to be displayed for users inside labs */

/** The message alert level */
export let LabSystemMessageAlertLevel = /*#__PURE__*/function (LabSystemMessageAlertLevel) {
  /** Represents an error message for the lab, e.g. an ongoing maintenance for the lab */
  LabSystemMessageAlertLevel["Error"] = "ERROR";
  /** Represents an informational message, e.g. an upcoming maintenance for the lab */
  LabSystemMessageAlertLevel["Information"] = "INFORMATION";
  /** Represents a success message, e.g. a new feature was added for the lab */
  LabSystemMessageAlertLevel["Success"] = "SUCCESS";
  /** Represents a warning message, e.g. there could be slowness launching the lab */
  LabSystemMessageAlertLevel["Warning"] = "WARNING";
  return LabSystemMessageAlertLevel;
}({});

/** A task to be completed by users within the lab's workspace */

/** A required or optional resource for completing a lab task */

/** The type of a lab task resource */
export let LabTaskResourceType = /*#__PURE__*/function (LabTaskResourceType) {
  /** An asset resource, e.g. a file or an image */
  LabTaskResourceType["Asset"] = "ASSET";
  /** A miscellaneous documentation resource, e.g. a markdown file */
  LabTaskResourceType["Documentation"] = "DOCUMENTATION";
  /** A resource documenting how to accomplish a lab task */
  LabTaskResourceType["HowTo"] = "HOW_TO";
  /** A source code resource, e.g. a reference code archive file */
  LabTaskResourceType["SolutionSourceCode"] = "SOLUTION_SOURCE_CODE";
  /** Default state; the resource type is not specified */
  LabTaskResourceType["Unspecified"] = "UNSPECIFIED";
  return LabTaskResourceType;
}({});

/** The publishing status of a lab task */
export let LabTaskStatus = /*#__PURE__*/function (LabTaskStatus) {
  /** Default state; Task is still being edited by the instructor */
  LabTaskStatus["Draft"] = "DRAFT";
  /** Task is published and ready for learners to complete */
  LabTaskStatus["Published"] = "PUBLISHED";
  return LabTaskStatus;
}({});

/** The LanguageCode scalar type as defined by ISO 639-1. */
export let LanguageCode = /*#__PURE__*/function (LanguageCode) {
  /** Afrikaans */
  LanguageCode["Af"] = "AF";
  /** Akan */
  LanguageCode["Ak"] = "AK";
  /** Amharic */
  LanguageCode["Am"] = "AM";
  /** Arabic */
  LanguageCode["Ar"] = "AR";
  /** Assamese */
  LanguageCode["As"] = "AS";
  /** Azerbaijani */
  LanguageCode["Az"] = "AZ";
  /** Belarusian */
  LanguageCode["Be"] = "BE";
  /** Bulgarian */
  LanguageCode["Bg"] = "BG";
  /** Bambara */
  LanguageCode["Bm"] = "BM";
  /** Bangla */
  LanguageCode["Bn"] = "BN";
  /** Tibetan */
  LanguageCode["Bo"] = "BO";
  /** Breton */
  LanguageCode["Br"] = "BR";
  /** Bosnian */
  LanguageCode["Bs"] = "BS";
  /** Catalan */
  LanguageCode["Ca"] = "CA";
  /** Chechen */
  LanguageCode["Ce"] = "CE";
  /** Czech */
  LanguageCode["Cs"] = "CS";
  /** Church Slavic */
  LanguageCode["Cu"] = "CU";
  /** Welsh */
  LanguageCode["Cy"] = "CY";
  /** Danish */
  LanguageCode["Da"] = "DA";
  /** German */
  LanguageCode["De"] = "DE";
  /** Dzongkha */
  LanguageCode["Dz"] = "DZ";
  /** Ewe */
  LanguageCode["Ee"] = "EE";
  /** Greek */
  LanguageCode["El"] = "EL";
  /** English */
  LanguageCode["En"] = "EN";
  /** Esperanto */
  LanguageCode["Eo"] = "EO";
  /** Spanish */
  LanguageCode["Es"] = "ES";
  /** Estonian */
  LanguageCode["Et"] = "ET";
  /** Basque */
  LanguageCode["Eu"] = "EU";
  /** Persian */
  LanguageCode["Fa"] = "FA";
  /** Fulah */
  LanguageCode["Ff"] = "FF";
  /** Finnish */
  LanguageCode["Fi"] = "FI";
  /** Faroese */
  LanguageCode["Fo"] = "FO";
  /** French */
  LanguageCode["Fr"] = "FR";
  /** Western Frisian */
  LanguageCode["Fy"] = "FY";
  /** Irish */
  LanguageCode["Ga"] = "GA";
  /** Scottish Gaelic */
  LanguageCode["Gd"] = "GD";
  /** Galician */
  LanguageCode["Gl"] = "GL";
  /** Gujarati */
  LanguageCode["Gu"] = "GU";
  /** Manx */
  LanguageCode["Gv"] = "GV";
  /** Hausa */
  LanguageCode["Ha"] = "HA";
  /** Hebrew */
  LanguageCode["He"] = "HE";
  /** Hindi */
  LanguageCode["Hi"] = "HI";
  /** Croatian */
  LanguageCode["Hr"] = "HR";
  /** Hungarian */
  LanguageCode["Hu"] = "HU";
  /** Armenian */
  LanguageCode["Hy"] = "HY";
  /** Interlingua */
  LanguageCode["Ia"] = "IA";
  /** Indonesian */
  LanguageCode["Id"] = "ID";
  /** Igbo */
  LanguageCode["Ig"] = "IG";
  /** Sichuan Yi */
  LanguageCode["Ii"] = "II";
  /** Icelandic */
  LanguageCode["Is"] = "IS";
  /** Italian */
  LanguageCode["It"] = "IT";
  /** Japanese */
  LanguageCode["Ja"] = "JA";
  /** Javanese */
  LanguageCode["Jv"] = "JV";
  /** Georgian */
  LanguageCode["Ka"] = "KA";
  /** Kikuyu */
  LanguageCode["Ki"] = "KI";
  /** Kazakh */
  LanguageCode["Kk"] = "KK";
  /** Kalaallisut */
  LanguageCode["Kl"] = "KL";
  /** Khmer */
  LanguageCode["Km"] = "KM";
  /** Kannada */
  LanguageCode["Kn"] = "KN";
  /** Korean */
  LanguageCode["Ko"] = "KO";
  /** Kashmiri */
  LanguageCode["Ks"] = "KS";
  /** Kurdish */
  LanguageCode["Ku"] = "KU";
  /** Cornish */
  LanguageCode["Kw"] = "KW";
  /** Kyrgyz */
  LanguageCode["Ky"] = "KY";
  /** Luxembourgish */
  LanguageCode["Lb"] = "LB";
  /** Ganda */
  LanguageCode["Lg"] = "LG";
  /** Lingala */
  LanguageCode["Ln"] = "LN";
  /** Lao */
  LanguageCode["Lo"] = "LO";
  /** Lithuanian */
  LanguageCode["Lt"] = "LT";
  /** Luba-Katanga */
  LanguageCode["Lu"] = "LU";
  /** Latvian */
  LanguageCode["Lv"] = "LV";
  /** Malagasy */
  LanguageCode["Mg"] = "MG";
  /** Māori */
  LanguageCode["Mi"] = "MI";
  /** Macedonian */
  LanguageCode["Mk"] = "MK";
  /** Malayalam */
  LanguageCode["Ml"] = "ML";
  /** Mongolian */
  LanguageCode["Mn"] = "MN";
  /** Marathi */
  LanguageCode["Mr"] = "MR";
  /** Malay */
  LanguageCode["Ms"] = "MS";
  /** Maltese */
  LanguageCode["Mt"] = "MT";
  /** Burmese */
  LanguageCode["My"] = "MY";
  /** Norwegian (Bokmål) */
  LanguageCode["Nb"] = "NB";
  /** North Ndebele */
  LanguageCode["Nd"] = "ND";
  /** Nepali */
  LanguageCode["Ne"] = "NE";
  /** Dutch */
  LanguageCode["Nl"] = "NL";
  /** Norwegian Nynorsk */
  LanguageCode["Nn"] = "NN";
  /** Norwegian */
  LanguageCode["No"] = "NO";
  /** Oromo */
  LanguageCode["Om"] = "OM";
  /** Odia */
  LanguageCode["Or"] = "OR";
  /** Ossetic */
  LanguageCode["Os"] = "OS";
  /** Punjabi */
  LanguageCode["Pa"] = "PA";
  /** Polish */
  LanguageCode["Pl"] = "PL";
  /** Pashto */
  LanguageCode["Ps"] = "PS";
  /** Portuguese */
  LanguageCode["Pt"] = "PT";
  /** Portuguese (Brazil) */
  LanguageCode["PtBr"] = "PT_BR";
  /** Portuguese (Portugal) */
  LanguageCode["PtPt"] = "PT_PT";
  /** Quechua */
  LanguageCode["Qu"] = "QU";
  /** Romansh */
  LanguageCode["Rm"] = "RM";
  /** Rundi */
  LanguageCode["Rn"] = "RN";
  /** Romanian */
  LanguageCode["Ro"] = "RO";
  /** Russian */
  LanguageCode["Ru"] = "RU";
  /** Kinyarwanda */
  LanguageCode["Rw"] = "RW";
  /** Sindhi */
  LanguageCode["Sd"] = "SD";
  /** Northern Sami */
  LanguageCode["Se"] = "SE";
  /** Sango */
  LanguageCode["Sg"] = "SG";
  /** Sinhala */
  LanguageCode["Si"] = "SI";
  /** Slovak */
  LanguageCode["Sk"] = "SK";
  /** Slovenian */
  LanguageCode["Sl"] = "SL";
  /** Shona */
  LanguageCode["Sn"] = "SN";
  /** Somali */
  LanguageCode["So"] = "SO";
  /** Albanian */
  LanguageCode["Sq"] = "SQ";
  /** Serbian */
  LanguageCode["Sr"] = "SR";
  /** Sundanese */
  LanguageCode["Su"] = "SU";
  /** Swedish */
  LanguageCode["Sv"] = "SV";
  /** Swahili */
  LanguageCode["Sw"] = "SW";
  /** Tamil */
  LanguageCode["Ta"] = "TA";
  /** Telugu */
  LanguageCode["Te"] = "TE";
  /** Tajik */
  LanguageCode["Tg"] = "TG";
  /** Thai */
  LanguageCode["Th"] = "TH";
  /** Tigrinya */
  LanguageCode["Ti"] = "TI";
  /** Turkmen */
  LanguageCode["Tk"] = "TK";
  /** Tongan */
  LanguageCode["To"] = "TO";
  /** Turkish */
  LanguageCode["Tr"] = "TR";
  /** Tatar */
  LanguageCode["Tt"] = "TT";
  /** Uyghur */
  LanguageCode["Ug"] = "UG";
  /** Ukrainian */
  LanguageCode["Uk"] = "UK";
  /** Urdu */
  LanguageCode["Ur"] = "UR";
  /** Uzbek */
  LanguageCode["Uz"] = "UZ";
  /** Vietnamese */
  LanguageCode["Vi"] = "VI";
  /** Volapük */
  LanguageCode["Vo"] = "VO";
  /** Wolof */
  LanguageCode["Wo"] = "WO";
  /** Xhosa */
  LanguageCode["Xh"] = "XH";
  /** Yiddish */
  LanguageCode["Yi"] = "YI";
  /** Yoruba */
  LanguageCode["Yo"] = "YO";
  /** Chinese */
  LanguageCode["Zh"] = "ZH";
  /** Chinese (Simplified) */
  LanguageCode["ZhCn"] = "ZH_CN";
  /** Chinese (Traditional) */
  LanguageCode["ZhTw"] = "ZH_TW";
  /** Zulu */
  LanguageCode["Zu"] = "ZU";
  return LanguageCode;
}({});

/** Scope of the data for the insights. It can be for all courses or for ub courses only. If it is for ub courses only, the data will be filtered by the courses that are for the ub only. If it is for all courses, the data will not be filtered */
export let LearnerChannel = /*#__PURE__*/function (LearnerChannel) {
  /** All courses */
  LearnerChannel["All"] = "ALL";
  /** For ub courses only */
  LearnerChannel["Ub"] = "UB";
  return LearnerChannel;
}({});

/** Represents the learning activity period like daily or monthly and the corresponding date in value. For monthly, day portion in the value will be 1st of the month. */

/** Contains records of time spent in a learning activity */

/** Filters used to fetch summary of learning activity. */

/** Represents the learning activity in trend view. */

/** Filters used to fetch learning activity. */

/** Base message item entity - add here any fields shared across all item types */

/** Input for sending an audio chat message */

/** Represents code blocks that can be shared within a chat message */

/** The programming languages available in Learning Assistant code blocks */
export let LearningAssistantChatCodeBlockLanguage = /*#__PURE__*/function (LearningAssistantChatCodeBlockLanguage) {
  /** Assembly */
  LearningAssistantChatCodeBlockLanguage["Assembly"] = "ASSEMBLY";
  /** Batch File */
  LearningAssistantChatCodeBlockLanguage["BatchFile"] = "BATCH_FILE";
  /** C */
  LearningAssistantChatCodeBlockLanguage["C"] = "C";
  /** Clojure */
  LearningAssistantChatCodeBlockLanguage["Clojure"] = "CLOJURE";
  /** CMake */
  LearningAssistantChatCodeBlockLanguage["Cmake"] = "CMAKE";
  /** COBOL */
  LearningAssistantChatCodeBlockLanguage["Cobol"] = "COBOL";
  /** CoffeeScript */
  LearningAssistantChatCodeBlockLanguage["Coffeescript"] = "COFFEESCRIPT";
  /** C++ */
  LearningAssistantChatCodeBlockLanguage["Cpp"] = "CPP";
  /** C# */
  LearningAssistantChatCodeBlockLanguage["Csharp"] = "CSHARP";
  /** CSS */
  LearningAssistantChatCodeBlockLanguage["Css"] = "CSS";
  /** CSV */
  LearningAssistantChatCodeBlockLanguage["Csv"] = "CSV";
  /** Dart */
  LearningAssistantChatCodeBlockLanguage["Dart"] = "DART";
  /** Default */
  LearningAssistantChatCodeBlockLanguage["Default"] = "DEFAULT";
  /** DM */
  LearningAssistantChatCodeBlockLanguage["Dm"] = "DM";
  /** Dockerfile */
  LearningAssistantChatCodeBlockLanguage["Dockerfile"] = "DOCKERFILE";
  /** Elixir */
  LearningAssistantChatCodeBlockLanguage["Elixir"] = "ELIXIR";
  /** Erlang */
  LearningAssistantChatCodeBlockLanguage["Erlang"] = "ERLANG";
  /** Fortran */
  LearningAssistantChatCodeBlockLanguage["Fortran"] = "FORTRAN";
  /** Go */
  LearningAssistantChatCodeBlockLanguage["Go"] = "GO";
  /** Groovy */
  LearningAssistantChatCodeBlockLanguage["Groovy"] = "GROOVY";
  /** Haskell */
  LearningAssistantChatCodeBlockLanguage["Haskell"] = "HASKELL";
  /** HTML */
  LearningAssistantChatCodeBlockLanguage["Html"] = "HTML";
  /** INI */
  LearningAssistantChatCodeBlockLanguage["Ini"] = "INI";
  /** Java */
  LearningAssistantChatCodeBlockLanguage["Java"] = "JAVA";
  /** JavaScript */
  LearningAssistantChatCodeBlockLanguage["Javascript"] = "JAVASCRIPT";
  /** JSON */
  LearningAssistantChatCodeBlockLanguage["Json"] = "JSON";
  /** Julia */
  LearningAssistantChatCodeBlockLanguage["Julia"] = "JULIA";
  /** Kotlin */
  LearningAssistantChatCodeBlockLanguage["Kotlin"] = "KOTLIN";
  /** Lisp */
  LearningAssistantChatCodeBlockLanguage["Lisp"] = "LISP";
  /** Lua */
  LearningAssistantChatCodeBlockLanguage["Lua"] = "LUA";
  /** Makefile */
  LearningAssistantChatCodeBlockLanguage["Makefile"] = "MAKEFILE";
  /** Markdown */
  LearningAssistantChatCodeBlockLanguage["Markdown"] = "MARKDOWN";
  /** MATLAB */
  LearningAssistantChatCodeBlockLanguage["Matlab"] = "MATLAB";
  /** Objective-C */
  LearningAssistantChatCodeBlockLanguage["ObjectiveC"] = "OBJECTIVE_C";
  /** OCaml */
  LearningAssistantChatCodeBlockLanguage["Ocaml"] = "OCAML";
  /** Pascal */
  LearningAssistantChatCodeBlockLanguage["Pascal"] = "PASCAL";
  /** Perl */
  LearningAssistantChatCodeBlockLanguage["Perl"] = "PERL";
  /** PHP */
  LearningAssistantChatCodeBlockLanguage["Php"] = "PHP";
  /** PowerShell */
  LearningAssistantChatCodeBlockLanguage["Powershell"] = "POWERSHELL";
  /** Prolog */
  LearningAssistantChatCodeBlockLanguage["Prolog"] = "PROLOG";
  /** Python */
  LearningAssistantChatCodeBlockLanguage["Python"] = "PYTHON";
  /** R */
  LearningAssistantChatCodeBlockLanguage["R"] = "R";
  /** Ruby */
  LearningAssistantChatCodeBlockLanguage["Ruby"] = "RUBY";
  /** Rust */
  LearningAssistantChatCodeBlockLanguage["Rust"] = "RUST";
  /** Scala */
  LearningAssistantChatCodeBlockLanguage["Scala"] = "SCALA";
  /** Shell */
  LearningAssistantChatCodeBlockLanguage["Shell"] = "SHELL";
  /** SQL */
  LearningAssistantChatCodeBlockLanguage["Sql"] = "SQL";
  /** Swift */
  LearningAssistantChatCodeBlockLanguage["Swift"] = "SWIFT";
  /** TeX */
  LearningAssistantChatCodeBlockLanguage["Tex"] = "TEX";
  /** TOML */
  LearningAssistantChatCodeBlockLanguage["Toml"] = "TOML";
  /** TypeScript */
  LearningAssistantChatCodeBlockLanguage["Typescript"] = "TYPESCRIPT";
  /** Verilog */
  LearningAssistantChatCodeBlockLanguage["Verilog"] = "VERILOG";
  /** Visual Basic */
  LearningAssistantChatCodeBlockLanguage["VisualBasic"] = "VISUAL_BASIC";
  /** XML */
  LearningAssistantChatCodeBlockLanguage["Xml"] = "XML";
  /** YAML */
  LearningAssistantChatCodeBlockLanguage["Yaml"] = "YAML";
  return LearningAssistantChatCodeBlockLanguage;
}({});

/** Input for generic chat context */

/** Input for role play context */

/** Input for chat message history context */

/** Input for chat message context */

/** Input to submit a chat feedback form */

/** Input to submit a chat feedback */

/** Submit chat feedback response */

/** Base interface for file objects shared via the chat assistant */

/** Represents a file message shared in the chat, retrievable from learning assistant cloud storage */

/** Represents a list of files that can be shared within a chat message */

/** Response for initiating a chat session */

/** Represents Udemy instructors given by the assistant  */

/** Input for feeding chat context */

/** Response for the mutation to send chat interactions */

/** Interaction type for the client interaction with the Learning Assistant */
export let LearningAssistantChatInteractionType = /*#__PURE__*/function (LearningAssistantChatInteractionType) {
  /** Generic Text interaction type */
  LearningAssistantChatInteractionType["Generic"] = "GENERIC";
  /** Lab Task Presented interaction type */
  LearningAssistantChatInteractionType["LabTaskPresented"] = "LAB_TASK_PRESENTED";
  /** Practice Test Answer Checked interaction type */
  LearningAssistantChatInteractionType["PracticeTestAnswerChecked"] = "PRACTICE_TEST_ANSWER_CHECKED";
  /** Practice Test Question Presented interaction type */
  LearningAssistantChatInteractionType["PracticeTestQuestionPresented"] = "PRACTICE_TEST_QUESTION_PRESENTED";
  /** Quiz Answer Checked interaction type */
  LearningAssistantChatInteractionType["QuizAnswerChecked"] = "QUIZ_ANSWER_CHECKED";
  /** Quiz Question Presented interaction type */
  LearningAssistantChatInteractionType["QuizQuestionPresented"] = "QUIZ_QUESTION_PRESENTED";
  return LearningAssistantChatInteractionType;
}({});

/** Represent learning products that can be shared within a chat message (deprecated) */

/** Represent learning products or curriculum items that can be shared within a chat message */

/** Represent a chat message */

/** Union of possible chat message items */

/** Represents the roles of chat messages */
export let LearningAssistantChatMessageRole = /*#__PURE__*/function (LearningAssistantChatMessageRole) {
  /** Represents messages generated by the learning assistant */
  LearningAssistantChatMessageRole["Assistant"] = "ASSISTANT";
  /** Represents messages sent by users */
  LearningAssistantChatMessageRole["User"] = "USER";
  return LearningAssistantChatMessageRole;
}({});

/** Response for sending a chat message */

/** Paginated chat messages */

/** Represents different types of chat sessions */
export let LearningAssistantChatName = /*#__PURE__*/function (LearningAssistantChatName) {
  /** Discovery Chat */
  LearningAssistantChatName["DiscoveryChat"] = "DISCOVERY_CHAT";
  /** Generic Chat */
  LearningAssistantChatName["GenericChat"] = "GENERIC_CHAT";
  /** In Course Chat */
  LearningAssistantChatName["InCourseChat"] = "IN_COURSE_CHAT";
  /** Interactive Question Generation Chat */
  LearningAssistantChatName["IqgChat"] = "IQG_CHAT";
  /** Learner Profile Chat */
  LearningAssistantChatName["LearnerProfileChat"] = "LEARNER_PROFILE_CHAT";
  /** Role Play Chat */
  LearningAssistantChatName["RolePlayChat"] = "ROLE_PLAY_CHAT";
  /** Skills Chat */
  LearningAssistantChatName["SkillsChat"] = "SKILLS_CHAT";
  return LearningAssistantChatName;
}({});

/** Common fields returned by chat-related responses */

/** Common error structure for Learning Assistant chat responses */

/** Response for terminating the chat session */

/** Represent a text message that can be shared within a chat message */

/** Input for sending a text chat message */

/** Input for requesting a new upload URL */

/** Represent a curriculum item that extends an actual curriculum item */

/** Error codes for Learning Assistant chat operations */
export let LearningAssistantErrorCode = /*#__PURE__*/function (LearningAssistantErrorCode) {
  /** If chat context is not found */
  LearningAssistantErrorCode["ErrorCodeChatContextNotFound"] = "ERROR_CODE_CHAT_CONTEXT_NOT_FOUND";
  /** If chat id is not available */
  LearningAssistantErrorCode["ErrorCodeChatIdRequired"] = "ERROR_CODE_CHAT_ID_REQUIRED";
  /** If chat message is not available */
  LearningAssistantErrorCode["ErrorCodeChatMessageRequired"] = "ERROR_CODE_CHAT_MESSAGE_REQUIRED";
  /** If chat session is expired */
  LearningAssistantErrorCode["ErrorCodeChatSessionExpired"] = "ERROR_CODE_CHAT_SESSION_EXPIRED";
  /** If course id is not available */
  LearningAssistantErrorCode["ErrorCodeCourseIdRequired"] = "ERROR_CODE_COURSE_ID_REQUIRED";
  /** Empty audio file content */
  LearningAssistantErrorCode["ErrorCodeEmptyAudioFileContent"] = "ERROR_CODE_EMPTY_AUDIO_FILE_CONTENT";
  /** If file content type is not supported */
  LearningAssistantErrorCode["ErrorCodeFileUnsupportedContentType"] = "ERROR_CODE_FILE_UNSUPPORTED_CONTENT_TYPE";
  /** Unexpected caught error. */
  LearningAssistantErrorCode["ErrorCodeInternalError"] = "ERROR_CODE_INTERNAL_ERROR";
  /** If the course id is not valid */
  LearningAssistantErrorCode["ErrorCodeInvalidCourseId"] = "ERROR_CODE_INVALID_COURSE_ID";
  /** If user message length is more than the max. Right not max is 2500 char. */
  LearningAssistantErrorCode["ErrorCodeMaxUserMessageLength"] = "ERROR_CODE_MAX_USER_MESSAGE_LENGTH";
  /** Content Flagged */
  LearningAssistantErrorCode["ErrorCodeModerationFlagged"] = "ERROR_CODE_MODERATION_FLAGGED";
  /** If user does not have a permission to initialize chat. This is own by exp platform flag to avoid unwanted access */
  LearningAssistantErrorCode["ErrorCodeNotAuthorized"] = "ERROR_CODE_NOT_AUTHORIZED";
  /** If input contains PII (Not active right now) */
  LearningAssistantErrorCode["ErrorCodePiiDetected"] = "ERROR_CODE_PII_DETECTED";
  /** If chat message is failure to process */
  LearningAssistantErrorCode["ErrorCodeProcessingIsFailed"] = "ERROR_CODE_PROCESSING_IS_FAILED";
  /** If one of quota limit is exceeded */
  LearningAssistantErrorCode["ErrorCodeQuotaLimitExceeded"] = "ERROR_CODE_QUOTA_LIMIT_EXCEEDED";
  /** If code session limit is exceeded */
  LearningAssistantErrorCode["ErrorCodeSessionMessageLimitExceeded"] = "ERROR_CODE_SESSION_MESSAGE_LIMIT_EXCEEDED";
  /** If code session is not found */
  LearningAssistantErrorCode["ErrorCodeSessionNotFound"] = "ERROR_CODE_SESSION_NOT_FOUND";
  /** If since request parameter is not available */
  LearningAssistantErrorCode["ErrorCodeSinceIsRequired"] = "ERROR_CODE_SINCE_IS_REQUIRED";
  /** If user send a new message before former message is still processing. */
  LearningAssistantErrorCode["ErrorCodeTooManyRequest"] = "ERROR_CODE_TOO_MANY_REQUEST";
  /** Unspecified error */
  LearningAssistantErrorCode["ErrorCodeUnspecified"] = "ERROR_CODE_UNSPECIFIED";
  /** If input contains own user id */
  LearningAssistantErrorCode["ErrorCodeUserIdDetectedInMessage"] = "ERROR_CODE_USER_ID_DETECTED_IN_MESSAGE";
  /** If user id is not found */
  LearningAssistantErrorCode["ErrorCodeUserIdNotFound"] = "ERROR_CODE_USER_ID_NOT_FOUND";
  return LearningAssistantErrorCode;
}({});

/** Input representing a file context passed into the chat, including file metadata and its temporary access URL. */

/** Supported file MIME types */
export let LearningAssistantFileMimeType = /*#__PURE__*/function (LearningAssistantFileMimeType) {
  /** GIF image */
  LearningAssistantFileMimeType["Gif"] = "GIF";
  /** JPEG image */
  LearningAssistantFileMimeType["Jpeg"] = "JPEG";
  /** PDF image */
  LearningAssistantFileMimeType["Pdf"] = "PDF";
  /** PNG image */
  LearningAssistantFileMimeType["Png"] = "PNG";
  /** WEBP image */
  LearningAssistantFileMimeType["Webp"] = "WEBP";
  return LearningAssistantFileMimeType;
}({});

/** Response containing a presigned URL for either uploading or downloading a file, depending on the context of the request. For upload: the URL is used with PUT. For download: the URL is used with GET */

/** List of presigned URLs */

/** Send when user selects a lab task */

/** Represent a learning assistant-specific learning product that extends an actual learning product */

/** Union of possible chat message item types that can be shared within a chat message item */

/** User checks (submits) a practice test answer */

/** User sees a practice test question */

/** User checks (submits) a quiz answer (text fields are exactly as seen on the UI) */

/** User sees a quiz question (text fields are exactly as seen on the UI) */

/** Enhanced suggested prompt with categorization for future UI differentiation */

/** Represents the category of a suggested prompt matches backend enum */
export let LearningAssistantSuggestedPromptCategory = /*#__PURE__*/function (LearningAssistantSuggestedPromptCategory) {
  /** Prompt suggested category (enum) AIA capability */
  LearningAssistantSuggestedPromptCategory["AiaCapability"] = "AIA_CAPABILITY";
  /** Prompt suggested category (enum) content based */
  LearningAssistantSuggestedPromptCategory["ContentBasedPrompts"] = "CONTENT_BASED_PROMPTS";
  /** Prompt suggested category (enum) unspecified */
  LearningAssistantSuggestedPromptCategory["Unspecified"] = "UNSPECIFIED";
  return LearningAssistantSuggestedPromptCategory;
}({});

/** Represents all pages that support displaying suggested prompts */
export let LearningAssistantSuggestedPromptPageSource = /*#__PURE__*/function (LearningAssistantSuggestedPromptPageSource) {
  /** AI Assistant Page */
  LearningAssistantSuggestedPromptPageSource["AiAssistantPage"] = "AI_ASSISTANT_PAGE";
  /** Course Landing Page */
  LearningAssistantSuggestedPromptPageSource["CourseLandingPage"] = "COURSE_LANDING_PAGE";
  /** Course Taking Page */
  LearningAssistantSuggestedPromptPageSource["CourseTakingPage"] = "COURSE_TAKING_PAGE";
  /** Logged In Home Page */
  LearningAssistantSuggestedPromptPageSource["LoggedInHomePage"] = "LOGGED_IN_HOME_PAGE";
  /** Search Results Page */
  LearningAssistantSuggestedPromptPageSource["SearchResultsPage"] = "SEARCH_RESULTS_PAGE";
  return LearningAssistantSuggestedPromptPageSource;
}({});

/** Represents the subcategory of a suggested prompt matches backend enum */
export let LearningAssistantSuggestedPromptSubcategory = /*#__PURE__*/function (LearningAssistantSuggestedPromptSubcategory) {
  /** Prompt suggested subcategory (enum) Code debugging */
  LearningAssistantSuggestedPromptSubcategory["CodeDebugging"] = "CODE_DEBUGGING";
  /** Prompt suggested subcategory (enum) FAQ */
  LearningAssistantSuggestedPromptSubcategory["Faq"] = "FAQ";
  /** Prompt suggested subcategory (enum) Lecture based */
  LearningAssistantSuggestedPromptSubcategory["LectureBased"] = "LECTURE_BASED";
  /** Prompt suggested subcategory (enum) Lecture search */
  LearningAssistantSuggestedPromptSubcategory["LectureSearch"] = "LECTURE_SEARCH";
  /** Prompt suggested subcategory (enum) Lecture summarization */
  LearningAssistantSuggestedPromptSubcategory["LectureSummarization"] = "LECTURE_SUMMARIZATION";
  /** Prompt suggested subcategory (enum) Others */
  LearningAssistantSuggestedPromptSubcategory["Others"] = "OTHERS";
  /** Prompt suggested subcategory (enum) Quiz */
  LearningAssistantSuggestedPromptSubcategory["Quiz"] = "QUIZ";
  /** Prompt suggested subcategory (enum) Skills focused */
  LearningAssistantSuggestedPromptSubcategory["SkillsFocused"] = "SKILLS_FOCUSED";
  /** Prompt suggested subcategory (enum) unspecified */
  LearningAssistantSuggestedPromptSubcategory["Unspecified"] = "UNSPECIFIED";
  return LearningAssistantSuggestedPromptSubcategory;
}({});

/** Paginated suggested prompts */

/** Types of Udemy Instructors that the Assistant might respond with */

/** Generic interaction that enables faster implementation of new interaction types */

/** Represents BE entities that are not yet mapped to a GQL type */

/** Input for retrieving presigned URLs for previously uploaded files */

/** Quota (limit) that a user can have when interacting with the Learning Assistant */

/** Quota usage is determined by discrete integer values */

/** Response for fetching user quota */

/** Window of time to include user interactions with the Learning Assistant. Also, it represents the frequency by which the user quota is reset */
export let LearningAssistantUserQuotaTimespanType = /*#__PURE__*/function (LearningAssistantUserQuotaTimespanType) {
  /** User quota is determined by daily interactions */
  LearningAssistantUserQuotaTimespanType["Day"] = "DAY";
  /** User quota is determined by monthly interactions */
  LearningAssistantUserQuotaTimespanType["Month"] = "MONTH";
  /** User quota is determined by weekly interactions */
  LearningAssistantUserQuotaTimespanType["Week"] = "WEEK";
  return LearningAssistantUserQuotaTimespanType;
}({});

/** Entity used for calculating user quotas */
export let LearningAssistantUserQuotaType = /*#__PURE__*/function (LearningAssistantUserQuotaType) {
  /** Users have a quota based on their number of messages submitted */
  LearningAssistantUserQuotaType["MessageCount"] = "MESSAGE_COUNT";
  return LearningAssistantUserQuotaType;
}({});

/** Specifies how a quota usage is represented */

/** All active user quotas segregated by whether they have exceeded or not */

/** A learning objective is a brief statements that describe what students will be expected to learn. */

/** Represents the types of activities we can map to a Learning Objective. */

/** Allows the user to set the activity id's and the activity types they want to query for. */

/** Represent the types of activities we can map to a Learning Objective. */
export let LearningObjectiveActivityTypeInput = /*#__PURE__*/function (LearningObjectiveActivityTypeInput) {
  /** This activity is an Adaptive assessment question */
  LearningObjectiveActivityTypeInput["AssessmentQuestion"] = "ASSESSMENT_QUESTION";
  /** This activity is a course */
  LearningObjectiveActivityTypeInput["Course"] = "COURSE";
  /** This activity is a lab */
  LearningObjectiveActivityTypeInput["Lab"] = "LAB";
  /** This activity is a lab task */
  LearningObjectiveActivityTypeInput["LabTask"] = "LAB_TASK";
  /** This activity is a lecture */
  LearningObjectiveActivityTypeInput["Lecture"] = "LECTURE";
  return LearningObjectiveActivityTypeInput;
}({});

/** This holds data to create a learning objective */

/** Response for updating a Learning Objective */

/** The learning path object. */

/** Catalog of all learning paths available to the client */

/** Changes to catalog of all learning paths available to the client since last sync */

/** Collection of curriculum items presented in a learning path as a one item */

/** Response for creating/updating a learning path from skills */

/** Learning path enrollment */

/** Instructor for a Learning Path */

/** Learning Path Item can be Course, Lab, Assessment, Learning Path Resource, and Course Portion */

/** A wrapper type to include the recommended Learning Path and some additional fields about its recommendation */

/** Learning Path Resource represents a link to another resource */

/** Search filters to apply on path search request */

/** List of LearningPath and additional data about search response */

/** Learning Path Section represents a collection of items in a learning path */

/** All partner's content collection items that are available, currently just course */

/** Represents a request to access a specific learning product */

/** Response for approval operation on learning product access requests */

/** Represents the response for creating a learning product access request */

/** Status codes representing the result of processing access requests */
export let LearningProductAccessRequestProcessCode = /*#__PURE__*/function (LearningProductAccessRequestProcessCode) {
  /** Request could not be processed due to no available seats */
  LearningProductAccessRequestProcessCode["NoSeatsAvailable"] = "NO_SEATS_AVAILABLE";
  /** Request could not be processed because it was not found */
  LearningProductAccessRequestProcessCode["RequestNotFound"] = "REQUEST_NOT_FOUND";
  /** Request was processed successfully */
  LearningProductAccessRequestProcessCode["Success"] = "SUCCESS";
  /** Request could not be processed due to an internal error */
  LearningProductAccessRequestProcessCode["UnknownError"] = "UNKNOWN_ERROR";
  return LearningProductAccessRequestProcessCode;
}({});

/** Represents the result of processing an individual access request */

/** Response for rejection operation on learning product access requests */

/** Status of a learning product access request */
export let LearningProductAccessRequestStatus = /*#__PURE__*/function (LearningProductAccessRequestStatus) {
  /** Request has been approved */
  LearningProductAccessRequestStatus["Approved"] = "APPROVED";
  /** Request was auto-approved */
  LearningProductAccessRequestStatus["AutoApproved"] = "AUTO_APPROVED";
  /** Request is pending approval */
  LearningProductAccessRequestStatus["Pending"] = "PENDING";
  /** Request has been rejected */
  LearningProductAccessRequestStatus["Rejected"] = "REJECTED";
  return LearningProductAccessRequestStatus;
}({});

/** Paginated response for learning product access requests */

/** Represents a badge awarded to a learning product. */

/** Input for getting badge classes by learning products */

/** Type of learning product. */
export let LearningProductType = /*#__PURE__*/function (LearningProductType) {
  /** Assessment */
  LearningProductType["Assessment"] = "ASSESSMENT";
  /** Badge Class (OpenBadgeClass & OrganizationBadgeClass) */
  LearningProductType["BadgeClass"] = "BADGE_CLASS";
  /** Career Accelerator */
  LearningProductType["CareerAccelerator"] = "CAREER_ACCELERATOR";
  /** Course */
  LearningProductType["Course"] = "COURSE";
  /** Lab */
  LearningProductType["Lab"] = "LAB";
  /** Learning path */
  LearningProductType["LearningPath"] = "LEARNING_PATH";
  /** Practice test */
  LearningProductType["PracticeTest"] = "PRACTICE_TEST";
  return LearningProductType;
}({});

/** A collection of learning products for a partner */

/** The LearningReminder object. */

/** Calendar type of the learning reminder */
export let LearningReminderCalendarType = /*#__PURE__*/function (LearningReminderCalendarType) {
  /** Apple Calendar Type */
  LearningReminderCalendarType["Apple"] = "APPLE";
  /** Google Calendar Type */
  LearningReminderCalendarType["Google"] = "GOOGLE";
  /** Other Calendars */
  LearningReminderCalendarType["Other"] = "OTHER";
  /** Outlook Calendar Type */
  LearningReminderCalendarType["Outlook"] = "OUTLOOK";
  return LearningReminderCalendarType;
}({});

/** Response for creating or updating a learning reminder */

/** Response for deleting a learning reminder */

/** Input for creating and updating a learning reminder */

/** Input for learning product of the learning reminder */

/** Notification method of the learning reminder */
export let LearningReminderNotificationMethod = /*#__PURE__*/function (LearningReminderNotificationMethod) {
  /** Email Reminder Method */
  LearningReminderNotificationMethod["Email"] = "EMAIL";
  /** Push Reminder Method */
  LearningReminderNotificationMethod["Push"] = "PUSH";
  return LearningReminderNotificationMethod;
}({});

/** Paginated learning reminders of the user */

/** The testimonial given relevant to a learning item or event */

/** The Learning Testimonials query filter options */

/** The specific page type for the Learning Testimonial. This is important for narrowing down the testimonial content in the CMS to where Marketing wants to render it. (Other pages will be added in the future, e.g., Personal Plan, etc) */
export let LearningTestimonialPageType = /*#__PURE__*/function (LearningTestimonialPageType) {
  /** Logged out home page of udemy */
  LearningTestimonialPageType["LoggedOutHomePage"] = "LOGGED_OUT_HOME_PAGE";
  return LearningTestimonialPageType;
}({});

/** The source of the learning testimonial */

/** Type of Learning Testimonial */
export let LearningTestimonialType = /*#__PURE__*/function (LearningTestimonialType) {
  /** Case study Learning Testimonial */
  LearningTestimonialType["CaseStudy"] = "CASE_STUDY";
  /** Course review Learning Testimonial */
  LearningTestimonialType["CourseReview"] = "COURSE_REVIEW";
  /** Third party Learning Testimonial */
  LearningTestimonialType["ThirdParty"] = "THIRD_PARTY";
  return LearningTestimonialType;
}({});

/** Represents a lecture type  */

/** Represents a lecture type  */

/** Lecture images by varying dimensions */

/** A wrapper type to include the recommended Lecture and some additional fields about its recommendation */

/** List of LectureResults and additional data about search response */

/** Contains info for front end related stuff and tracking info. This data is calculated by backend service and used by Udemy front end. If you are an external user, you shouldn't need this. */

/** Identifies each result for lecture search. */

/** An AI-generated summary for a lecture */

/** A lesson associated with a learning product */

/** A rich article whose fragments can map to timestamps within the playable media */

/** A fragment of an article with possible mapping to the lesson's playable media */

/** Polymorphic Article Fragment Content */

/** A flexible identification for a lesson */

/** Input type for providing a lesson id */

/** The types of a LessonId */
export let LessonIdType = /*#__PURE__*/function (LessonIdType) {
  /** A lesson attached to an asset ID */
  LessonIdType["AssetId"] = "ASSET_ID";
  /** A standalone lesson with a UUID */
  LessonIdType["Uuid"] = "UUID";
  return LessonIdType;
}({});

/** License-related organization settings */

/** License pool */

/** Count of Active Users per Product Type per License Pool */

/** Response for a license pool create or update mutation */

/** Response for a license pool delete mutation */

/** The input used for creating and updating a license pool */

/** Product type license count */

/** The input used for describing a product type license count */

/** Response for a license pool update preview mutation */

/** Response for License Pool users move mutation */

/** License Pools users per SubscriptionPlanProductType of the pool */

/** Filters for the License Pools queries */

/** Enum for locale config options */
export let LocaleConfig = /*#__PURE__*/function (LocaleConfig) {
  /** Use the lesson's locale */
  LocaleConfig["LessonLocale"] = "LESSON_LOCALE";
  /** Use the user's locale */
  LocaleConfig["UserLocale"] = "USER_LOCALE";
  return LocaleConfig;
}({});

/** Input type for providing a locale configuration */

/** A micro-content representing markdown */

/** Single bullet item with optional icon. */

/** Call-to-action button with destination link. */

/**
 * Shared interface for all marketing card types in V1.
 * Ensures consistent core fields across different card implementations.
 */

/** Standard header copy used across marketing components. */

/** Marketing card with full background image and text content overlaid on top. */

/**
 * Marketing card with image positioned at the top and text content below.
 * Implements the shared MarketingCardV1 interface.
 */

/** Image asset used in marketing components. */

/** Two-column marketing section with intro copy on the left and a fixed row of cards on the right. */

/** Small pill UI element used in other components (icon + label). */

/** Two-column marketing section with copy with bullets on the left and an image on the right. */

/** Two-column hero with marketing copy on the left and a cards carousel on the right. */

/** Two-column marketing section with featured popular topic on the left and categorized topics on the right. */

/** Tabbed interface with header content where topic tabs control course card display. */

/** A category of topic with a header and list of topics. */

/** Current User */

/** Current User */

/** Enrollments of the current user */

/** Enrollments of the current user */

/** Enrollments of the current user */

/** Enrollments of the current user */

/** Enrollments of the current user */

/** The available media source MIME types for video/audio streaming and playback. */
export let MediaSourceType = /*#__PURE__*/function (MediaSourceType) {
  /** MPEG-DASH streaming manifest (.mpd) */
  MediaSourceType["ApplicationDashXml"] = "APPLICATION_DASH_XML";
  /** HLS streaming playlist (.m3u8) */
  MediaSourceType["ApplicationXMpegurl"] = "APPLICATION_X_MPEGURL";
  /** MP3 audio file */
  MediaSourceType["AudioMp3"] = "AUDIO_MP3";
  /** MP4 video file (progressive download) */
  MediaSourceType["VideoMp4"] = "VIDEO_MP4";
  return MediaSourceType;
}({});

/** Represents a key-value pair in metadata. */

/** Money */

/** Money input */

/** Price option for computed price plan. Will be returned for monthly plans */

/** Input for querying more RecommendationContextSections from a RecommendationContext */

/** Response returned when more RecommendationContextSections are queried for a RecommendationContext */

/** Input for querying more RecommendationItems from a RecommendationUnit */

/** Response returned when more RecommendationItems are queried for a RecommendationUnit */

/** Multi-select question. Several available options, with one or more correct answer options. */

/** Represents multiple choice quiz context */

/** Multiple-choice question. Several available options, with one and only one correct answer. */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Item in navigation list. */

/** Identifies the name of the navigation list. */
export let NavListName = /*#__PURE__*/function (NavListName) {
  /** The navigation tabs seen on category and subcategory landing pages. */
  NavListName["LinkBar"] = "LINK_BAR";
  /** The main navigation list seen in explore menu */
  NavListName["Main"] = "MAIN";
  return NavListName;
}({});

/** Represents a badge awarded to a new learning product. */

/** Details of Occupation */

/** User is assigning occupation to themself */

/** Occupation group type */

/** Current user assigning existing occupation group. */

/** Shows page search results of occupation */

/** Current user assigning user provided occupation. */

/** A wrapper type to include the recommended Occupation and some additional fields about its recommendation */

/** Filters for occupation search */

/** The OpenBadgeClass object. This implements the BadgeClass. */

/** A UB organization */

/** Represents an audit log entry for an organization. */

/** Input type for filtering organization logs. */

/** Background images for an organization */

/** The OrganizationBadgeClass object. This implements the BadgeClass. This has a few more issuer organization related fields. */

/** Response for creating a new organization badge class */

/** Response for deleting an organization badge class */

/** Additional details of the organization badge */

/** Input for creating a new organization badge class */

/** Response for updating an existing organization badge class */

/** Criteria for earning an organization badge by custom input */

/** Custom earning criteria input */

/** Interface for criteria for earning an organization badge */

/** Earning criteria input combined */

/** Criteria type for earning an organization badge */
export let OrganizationBadgeEarningCriteriaType = /*#__PURE__*/function (OrganizationBadgeEarningCriteriaType) {
  /** Criteria for earning an organization badge by custom input */
  OrganizationBadgeEarningCriteriaType["Custom"] = "CUSTOM";
  /** Criteria for earning an organization badge by learning product */
  OrganizationBadgeEarningCriteriaType["LearningProduct"] = "LEARNING_PRODUCT";
  return OrganizationBadgeEarningCriteriaType;
}({});

/** Criteria that is empty for earning an organization badge */

/** Criteria for earning an organization badge by learning product */

/** Learning Product earning criteria input */

/** Status of an OrganizationBadgeClass */
export let OrganizationBadgeStatus = /*#__PURE__*/function (OrganizationBadgeStatus) {
  /** Draft, can still be edited */
  OrganizationBadgeStatus["Draft"] = "DRAFT";
  /** Expired */
  OrganizationBadgeStatus["Expired"] = "EXPIRED";
  /** Published */
  OrganizationBadgeStatus["Published"] = "PUBLISHED";
  return OrganizationBadgeStatus;
}({});

/** Input for creation of organizations */

/** Response for Organization creation operation */

/** Favicon images for an organization */

/** Images for an organization */

/** Response object for Organization Insight progress buckets */

/** Response object for Organization Insight minutes range */

/** An input that accepts a start and end minutes */

/** Response object for Organization Insight learner count */

/** An input that accepts a range of dates to filter the data and buckets with start and end minutes */

/** Represents the organization learning goal */

/** Represents the input to create learning goal of an organization */

/** Represents the organization learning goal create response */

/** Represents the organization learning goal deactivate response */

/** Progress made by learners in organization towards the goal */

/** Represents the stats of learning goal of an organization */

/** Status of an organization learning goal */
export let OrganizationLearningGoalStatus = /*#__PURE__*/function (OrganizationLearningGoalStatus) {
  /** Learning goal is active */
  OrganizationLearningGoalStatus["Active"] = "ACTIVE";
  /** Learning goal is inactive */
  OrganizationLearningGoalStatus["Inactive"] = "INACTIVE";
  return OrganizationLearningGoalStatus;
}({});

/** Learning Path object that belongs to an organization */

/** Logo images for an organization */

/** Represents the each organization notification preference */

/** Represents the notification preferences of an organization */

/** Represents the organization notification save response */

/** Role-based organization notifications to group organization notifications by role */
export let OrganizationNotificationRoleType = /*#__PURE__*/function (OrganizationNotificationRoleType) {
  /** Represents every member of a particular organization */
  OrganizationNotificationRoleType["Everyone"] = "EVERYONE";
  /** Represents group admins of a particular organization */
  OrganizationNotificationRoleType["GroupAdmins"] = "GROUP_ADMINS";
  /** Represents learners of a particular organization */
  OrganizationNotificationRoleType["Learners"] = "LEARNERS";
  return OrganizationNotificationRoleType;
}({});

/** A notification preference belongs to organization */

/** A setting for an organization */

/** The setting names available for an organization */
export let OrganizationSettingName = /*#__PURE__*/function (OrganizationSettingName) {
  /** The setting to denote whether an organization is opted in to the AI Assistant GenAI feature */
  OrganizationSettingName["GenaiAiAssistantEnabled"] = "GENAI_AI_ASSISTANT_ENABLED";
  /** The setting to denote whether an organization is opted in to GenAI features */
  OrganizationSettingName["GenaiOptIn"] = "GENAI_OPT_IN";
  /** "The setting to denote whether an organization is opted in to the Role Play GenAI feature" */
  OrganizationSettingName["GenaiRolePlayEnabled"] = "GENAI_ROLE_PLAY_ENABLED";
  /** The setting to denote whether an organization is opted in to the Skills Mapping GenAI feature */
  OrganizationSettingName["GenaiSkillsMappingEnabled"] = "GENAI_SKILLS_MAPPING_ENABLED";
  /** The setting to denote whether sharing to Microsoft Teams is enabled */
  OrganizationSettingName["MsTeamsShare"] = "MS_TEAMS_SHARE";
  /** The setting denoting if recurring billing is enabled for the org */
  OrganizationSettingName["RecurringBilling"] = "RECURRING_BILLING";
  /** The setting to denote whether data should be sent to marketo */
  OrganizationSettingName["SendDataToMarketo"] = "SEND_DATA_TO_MARKETO";
  /** The setting to denote whether the sentiment survey is enabled */
  OrganizationSettingName["SentimentSurvey"] = "SENTIMENT_SURVEY";
  /** The setting to denote whether sharing to Slack is enabled */
  OrganizationSettingName["SlackShare"] = "SLACK_SHARE";
  /** The setting to denote whether the org is Team Plan V2 enabled */
  OrganizationSettingName["TpV2Enabled"] = "TP_V2_ENABLED";
  /** The setting to denote whether workplace sharing is enabled */
  OrganizationSettingName["WorkplaceShare"] = "WORKPLACE_SHARE";
  return OrganizationSettingName;
}({});

/** Input for setting overrides on organization settings. Only a specific set of settings (reflected in the params) can be overridden; in particular not all settings are meant to be self-serve, and some of them can only be set from Udemy. */

/** Response of setting overrides on organization settings. It returns all settings for the organization. */

/** Organization settings */

/** Organization Subscription */

/** Input for the Organization Subscription Creation */

/** Response for Adding Subscriptions to Organization */

/** Type of Trial Subscription for Organizations */
export let OrganizationSubscriptionTrialType = /*#__PURE__*/function (OrganizationSubscriptionTrialType) {
  /** Free trial subscription */
  OrganizationSubscriptionTrialType["IsFreeTrial"] = "IS_FREE_TRIAL";
  return OrganizationSubscriptionTrialType;
}({});

/** Type of an organization */
export let OrganizationType = /*#__PURE__*/function (OrganizationType) {
  /** Udemy Business */
  OrganizationType["UdemyBusiness"] = "UDEMY_BUSINESS";
  /** Udemy Business China */
  OrganizationType["UdemyBusinessChina"] = "UDEMY_BUSINESS_CHINA";
  /** Udemy Government */
  OrganizationType["UdemyGovernment"] = "UDEMY_GOVERNMENT";
  return OrganizationType;
}({});

/** Group identifiers within an organization to allow filtering the report data */

/** Object that describes the type and status of license assigned to a user in an organization */

/** Object that describes the status of license assigned to a user in an organization */
export let OrganizationUserLicenseStatus = /*#__PURE__*/function (OrganizationUserLicenseStatus) {
  /** license is usable and assigned to the specified user */
  OrganizationUserLicenseStatus["Active"] = "ACTIVE";
  /** license is not usable */
  OrganizationUserLicenseStatus["Inactive"] = "INACTIVE";
  return OrganizationUserLicenseStatus;
}({});

/** Object that describes the type of license assigned to a user in an organization */
export let OrganizationUserLicenseType = /*#__PURE__*/function (OrganizationUserLicenseType) {
  /** Default Enterprise and Team Plan license Type */
  OrganizationUserLicenseType["Basic"] = "BASIC";
  /** UB Pro license Type */
  OrganizationUserLicenseType["Pro"] = "PRO";
  return OrganizationUserLicenseType;
}({});

/** Filters for the organizationUserLicenses query */

/** Overrideable settings related to Licenses */

/** Interface for implementing paginated results */

/** A Partner */

/** Contains info for front end related stuff and tracking info. This data is calculated by backend service and used by Udemy front end. If you are an external user, you shouldn't need this. */

/** Enum for different payment method types */
export let PaymentMethodType = /*#__PURE__*/function (PaymentMethodType) {
  /** Payment method CHEQUE */
  PaymentMethodType["Cheque"] = "CHEQUE";
  /** Payment method JPMORGAN */
  PaymentMethodType["Jpmorgan"] = "JPMORGAN";
  /** Payment method PAYONEER */
  PaymentMethodType["Payoneer"] = "PAYONEER";
  /** Payment method PAYPAL */
  PaymentMethodType["Paypal"] = "PAYPAL";
  /** Payment method TIPALTI */
  PaymentMethodType["Tipalti"] = "TIPALTI";
  /** Payment method WIRE */
  PaymentMethodType["Wire"] = "WIRE";
  return PaymentMethodType;
}({});

/** Input for payout exists search filter */

/** Enum for different payout statuses */
export let PayoutStatusType = /*#__PURE__*/function (PayoutStatusType) {
  /** Payout status BLOCKED */
  PayoutStatusType["Blocked"] = "BLOCKED";
  /** Payout status CANCELLED */
  PayoutStatusType["Cancelled"] = "CANCELLED";
  /** Payout status DERECOGNIZED */
  PayoutStatusType["Derecognized"] = "DERECOGNIZED";
  /** Payout status FAILED */
  PayoutStatusType["Failed"] = "FAILED";
  /** Payout status INITIAL */
  PayoutStatusType["Initial"] = "INITIAL";
  /** Payout status PARTIALLY_SUCCESS */
  PayoutStatusType["PartiallySuccess"] = "PARTIALLY_SUCCESS";
  /** Payout status PENDING */
  PayoutStatusType["Pending"] = "PENDING";
  /** Payout status PROCESSING */
  PayoutStatusType["Processing"] = "PROCESSING";
  /** Payout status QUEUING */
  PayoutStatusType["Queuing"] = "QUEUING";
  /** Payout status READY_TO_PAY */
  PayoutStatusType["ReadyToPay"] = "READY_TO_PAY";
  /** Payout status SUCCESS */
  PayoutStatusType["Success"] = "SUCCESS";
  /** Payout status UNCLAIMED */
  PayoutStatusType["Unclaimed"] = "UNCLAIMED";
  /** Payout status UNPAID */
  PayoutStatusType["Unpaid"] = "UNPAID";
  return PayoutStatusType;
}({});

/** Player-related organization settings */

/** Popular topic */

/** Topic SubCategory */

/** Assigment test with multiple-choice and free-from questions reviewed by instructors */

/** Practice test that is more detailed than a Quiz */

/** Represents the selected choices of practice test context */

/** Represents practice test context for in-course chat */

/** Filters for practice test insights */

/** Presentation Lecture for Udemy Business */

/** Presentation Lecture for Udemy Business */

/** Price of the course, free or paid */
export let PriceOption = /*#__PURE__*/function (PriceOption) {
  /** Free */
  PriceOption["Free"] = "FREE";
  /** Paid */
  PriceOption["Paid"] = "PAID";
  return PriceOption;
}({});

/** The LearningPath only available for PRO subscriptions */

/** Instructor-friendly error message for failed assets */

/** The numbers of users which have attained each level */

/** Change in proficiency level counts over time */

/** Represents the pusher config */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Possible question types for practice test questions. */
export let QuestionType = /*#__PURE__*/function (QuestionType) {
  /** Question Type is fill_in_the_blank */
  QuestionType["FillInTheBlank"] = "FILL_IN_THE_BLANK";
  /** Question Type is multiple_choice */
  QuestionType["MultipleChoice"] = "MULTIPLE_CHOICE";
  /** Question Type is multiple_selection */
  QuestionType["MultipleSelection"] = "MULTIPLE_SELECTION";
  return QuestionType;
}({});

/** Quiz with simple questions and multiple choice / multi select answers */

/** An attempt of a quiz */

/** Represents quiz context for in-course chat */

/** A quiz item */

/** An option for a quiz item */

/** Response for a quiz item in an attempt */

/** Status of the response for a quiz item in an attempt */
export let QuizItemResponseStatus = /*#__PURE__*/function (QuizItemResponseStatus) {
  /** The item was answered correctly */
  QuizItemResponseStatus["Correct"] = "CORRECT";
  /** The item was answered incorrectly */
  QuizItemResponseStatus["Incorrect"] = "INCORRECT";
  /** The item was not answered */
  QuizItemResponseStatus["NotAnswered"] = "NOT_ANSWERED";
  /** The item was skipped */
  QuizItemResponseStatus["Skipped"] = "SKIPPED";
  return QuizItemResponseStatus;
}({});

/** Input request to submit an answer for a quiz item */

/** Paginated response for quiz items in a quiz */

/**
 * This is a top level grouping comprising all recommendations queried by a context code (ID of this object).
 *
 * Usually, this corresponds to the entire page of the application. In that case, there would be just one recommendation
 * context on a single page. The biggest advantage of serving all recommendations in one response, is the ability to
 * run unit ranking and deduplication comprehensively for the entire recommendation context.
 *
 * Even though, it is common to see a single page of the application uses only one recommendation context, it is not an
 * obligation. The 'page' and 'context' concepts are decoupled. Having multiple contexts on a page might be acceptable
 * if the trade-offs about compromising comprehensive ranking and deduplication are evaluated.
 *
 * RecommendationContext doesn't directly contain a list of RecommendationItems. Instead, it has a list of sections.
 * The UI should follow this grouping while rendering the recommendations.
 */

/** All information required to query a recommendation context */

/** Response returned when a RecommendationContext is queried */

/** RecommendationContext comprises multiple sections. Sections might be a RecommendationUnit or RecommendationUnitGroup. */

/**
 * A recommendation item comprises the actual entity (ex. course) to be recommended and some additional fields required
 * specifically by the recommendations domain.
 */

/** Input version of RecommendationItem type to specify a recommendation item in queries */

/** Currently supported RecommendationItem types */
export let RecommendationItemType = /*#__PURE__*/function (RecommendationItemType) {
  /** The recommended object is a 'Assessment' */
  RecommendationItemType["Assessment"] = "ASSESSMENT";
  /** The recommended object is a 'Category' */
  RecommendationItemType["Category"] = "CATEGORY";
  /** The recommended object is a 'Coding Exercise' */
  RecommendationItemType["CodingExercise"] = "CODING_EXERCISE";
  /** The recommended object is a 'Course' */
  RecommendationItemType["Course"] = "COURSE";
  /** The recommended object is a 'Course Section' */
  RecommendationItemType["CourseSection"] = "COURSE_SECTION";
  /** The recommended object is a 'Instructor' */
  RecommendationItemType["Instructor"] = "INSTRUCTOR";
  /** The recommended object is a 'Lab' */
  RecommendationItemType["Lab"] = "LAB";
  /** The recommended object is a 'Label (aka. Topic)' */
  RecommendationItemType["Label"] = "LABEL";
  /** The recommended object is a 'Learning Path' */
  RecommendationItemType["LearningPath"] = "LEARNING_PATH";
  /** The recommended object is a 'Lecture' */
  RecommendationItemType["Lecture"] = "LECTURE";
  /** The recommended object is a 'Occupation' */
  RecommendationItemType["Occupation"] = "OCCUPATION";
  /** The recommended object is a 'SubCategory' */
  RecommendationItemType["Subcategory"] = "SUBCATEGORY";
  return RecommendationItemType;
}({});

/** A type to specify what objects were used as a source object (seed) for a recommendation unit */

/** Input version of RecommendationSourceObject */

/** Currently supported recommendation source (aka. seed) object types */
export let RecommendationSourceObjectType = /*#__PURE__*/function (RecommendationSourceObjectType) {
  /** The type of recommendation source (aka. seed) object is 'Category' */
  RecommendationSourceObjectType["Category"] = "CATEGORY";
  /** The type of recommendation source (aka. seed) object is 'Collection' */
  RecommendationSourceObjectType["Collection"] = "COLLECTION";
  /** The type of recommendation source (aka. seed) object is 'Course' */
  RecommendationSourceObjectType["Course"] = "COURSE";
  /** The type of recommendation source (aka. seed) object is 'Instructor' */
  RecommendationSourceObjectType["Instructor"] = "INSTRUCTOR";
  /** The type of recommendation source (aka. seed) object is 'Label (aka. Topic)' */
  RecommendationSourceObjectType["Label"] = "LABEL";
  /** The type of recommendation source (aka. seed) object is 'Language' */
  RecommendationSourceObjectType["Language"] = "LANGUAGE";
  /** The type of recommendation source (aka. seed) object is 'Lecture' */
  RecommendationSourceObjectType["Lecture"] = "LECTURE";
  /** The type of recommendation source (aka. seed) object is 'Management Occupation' */
  RecommendationSourceObjectType["ManagementOccupation"] = "MANAGEMENT_OCCUPATION";
  /** The type of recommendation source (aka. seed) object is 'Occupation' */
  RecommendationSourceObjectType["Occupation"] = "OCCUPATION";
  /** The type of recommendation source (aka. seed) object is 'Occupation Group' */
  RecommendationSourceObjectType["OccupationGroup"] = "OCCUPATION_GROUP";
  /** The type of recommendation source (aka. seed) object is 'SubCategory' */
  RecommendationSourceObjectType["Subcategory"] = "SUBCATEGORY";
  return RecommendationSourceObjectType;
}({});

/**
 * Finest grained grouping of recommendations. Each recommendation unit corresponds to a specific algorithm,
 * source object (recommendation seed), and recommendation item type.
 */

/** Group of units that should be presented together. */

/** Date range for the report generation */
export let RelativeDateRange = /*#__PURE__*/function (RelativeDateRange) {
  /** Last 3 months */
  RelativeDateRange["Last_3Months"] = "LAST_3_MONTHS";
  /** Last 7 days */
  RelativeDateRange["Last_7Days"] = "LAST_7_DAYS";
  /** Last 30 days */
  RelativeDateRange["Last_30Days"] = "LAST_30_DAYS";
  /** Last year, whole months */
  RelativeDateRange["LastYear"] = "LAST_YEAR";
  /** Since activated */
  RelativeDateRange["SinceActivated"] = "SINCE_ACTIVATED";
  return RelativeDateRange;
}({});

/** Report job request */

/** Input type for report job */

/** Type of report job that can be scheduled or generated. */
export let ReportJobType = /*#__PURE__*/function (ReportJobType) {
  /** Courses export report job request */
  ReportJobType["CoursesExport"] = "COURSES_EXPORT";
  /** Course activity report job request */
  ReportJobType["CourseActivity"] = "COURSE_ACTIVITY";
  /** Custom course export job request */
  ReportJobType["CustomCourseExport"] = "CUSTOM_COURSE_EXPORT";
  /** Public path export job request */
  ReportJobType["PublicPathExport"] = "PUBLIC_PATH_EXPORT";
  /** Ratings and reviews report job request */
  ReportJobType["RatingsReviews"] = "RATINGS_REVIEWS";
  /** Subscription course export job request */
  ReportJobType["SubscriptionCourseExport"] = "SUBSCRIPTION_COURSE_EXPORT";
  /** Udemy path export job request */
  ReportJobType["UdemyPathExport"] = "UDEMY_PATH_EXPORT";
  /** All active users export job request */
  ReportJobType["UsersActive"] = "USERS_ACTIVE";
  /** All users export job request */
  ReportJobType["UsersAll"] = "USERS_ALL";
  /** Deactivated users export job request */
  ReportJobType["UsersDeactivated"] = "USERS_DEACTIVATED";
  /** Group admins export job request */
  ReportJobType["UsersGroupAdmin"] = "USERS_GROUP_ADMIN";
  /** Pending group admin invitations export job request */
  ReportJobType["UsersGroupAdminInvitations"] = "USERS_GROUP_ADMIN_INVITATIONS";
  /** Pending invitations export job request */
  ReportJobType["UsersInvitations"] = "USERS_INVITATIONS";
  /** Users not in a group export job request */
  ReportJobType["UsersNotInGroup"] = "USERS_NOT_IN_GROUP";
  /** User account activity report job request for reporting activation/deactivation */
  ReportJobType["UserAccountActivity"] = "USER_ACCOUNT_ACTIVITY";
  /** User activity report job request */
  ReportJobType["UserActivity"] = "USER_ACTIVITY";
  /** User activity all users report job request */
  ReportJobType["UserActivityAllUsers"] = "USER_ACTIVITY_ALL_USERS";
  /** User activity all users v2 report job request */
  ReportJobType["UserActivityAllUsersV2"] = "USER_ACTIVITY_ALL_USERS_V2";
  /** User activity trending report job request */
  ReportJobType["UserActivityTrending"] = "USER_ACTIVITY_TRENDING";
  /** User activity v2 report job request */
  ReportJobType["UserActivityV2"] = "USER_ACTIVITY_V2";
  /** User adoption funnel export job request */
  ReportJobType["UserAdoption"] = "USER_ADOPTION";
  /** Users without enrollment export job request */
  ReportJobType["UserAdoptionNotEnrolled"] = "USER_ADOPTION_NOT_ENROLLED";
  /** Users without activity export job request */
  ReportJobType["UserAdoptionNotWatched"] = "USER_ADOPTION_NOT_WATCHED";
  /** User assessment activity report job request */
  ReportJobType["UserAssessmentActivity"] = "USER_ASSESSMENT_ACTIVITY";
  /** User assessment proficiency report job request */
  ReportJobType["UserAssessmentProficiency"] = "USER_ASSESSMENT_PROFICIENCY";
  /** User badge activity report job request */
  ReportJobType["UserBadgeActivity"] = "USER_BADGE_ACTIVITY";
  /** User course activity report job request */
  ReportJobType["UserCourseActivity"] = "USER_COURSE_ACTIVITY";
  /** User lab activity report job request */
  ReportJobType["UserLabActivity"] = "USER_LAB_ACTIVITY";
  /** User progress report job request */
  ReportJobType["UserProgress"] = "USER_PROGRESS";
  /** User role play activity report job request */
  ReportJobType["UserRolePlayActivity"] = "USER_ROLE_PLAY_ACTIVITY";
  /** User skills activity report job request */
  ReportJobType["UserSkillsActivity"] = "USER_SKILLS_ACTIVITY";
  /** User skills proficiency report job request */
  ReportJobType["UserSkillsProficiency"] = "USER_SKILLS_PROFICIENCY";
  return ReportJobType;
}({});

/** Defines assistant's response type */
export let ResponseType = /*#__PURE__*/function (ResponseType) {
  /** The response is audio */
  ResponseType["Audio"] = "AUDIO";
  /** The response is text */
  ResponseType["Text"] = "TEXT";
  return ResponseType;
}({});

/** A review of a learning product */

/** Role-play activity for students to practice soft skills */

/** Schedule configuration */

/** Input type for schedule configuration */

/** Frequency of a schedule */
export let ScheduleFrequency = /*#__PURE__*/function (ScheduleFrequency) {
  /** Monthly */
  ScheduleFrequency["Monthly"] = "MONTHLY";
  /** Quarterly */
  ScheduleFrequency["Quarterly"] = "QUARTERLY";
  /** Weekly */
  ScheduleFrequency["Weekly"] = "WEEKLY";
  /** Yearly */
  ScheduleFrequency["Yearly"] = "YEARLY";
  return ScheduleFrequency;
}({});

/** Recurring scheduled report */

/** Input types for creating/updating scheduled reports */

/** Response object for scheduled report creation */

/** Identifies available search filter facets. */

/** Options for search aggregates */

/** One of the available options within a search facet type */

/** A simple auto-complete item can be search log, course or instructor */

/** Search Log suggestion for autocomplete */

/** Info about the page or component that sends the request */

/** Search Autocomplete request filters */

/** Search Autocomplete request metadata */

/** A simple autocomplete item with the tracking metadata */

/** Represents a search suggestion for a search */

/** Possible suggestion types for the search query. */
export let SearchQuerySuggestionType = /*#__PURE__*/function (SearchQuerySuggestionType) {
  /** 'Did you mean' suggestion for the search query. */
  SearchQuerySuggestionType["DidYouMean"] = "DID_YOU_MEAN";
  /** 'Rewrite' suggestion for the search query. */
  SearchQuerySuggestionType["Rewrite"] = "REWRITE";
  return SearchQuerySuggestionType;
}({});

/** Trigger types for the lab, lecture, assessment and path search. */
export let SearchTriggerType = /*#__PURE__*/function (SearchTriggerType) {
  /** Search triggered by the ChatGPT app */
  SearchTriggerType["ChatgptApp"] = "CHATGPT_APP";
  /** Search triggered by the MCP server */
  SearchTriggerType["McpServer"] = "MCP_SERVER";
  /** User inputs query */
  SearchTriggerType["UserQuery"] = "USER_QUERY";
  return SearchTriggerType;
}({});

/** Security-related organization settings */

/** A skills framework is a collection of learning objectives that are organized into a hierarchy. */

/** The goal for a skills framework which contains a set of learning objectives. */
export let SkillsFrameworkGoalType = /*#__PURE__*/function (SkillsFrameworkGoalType) {
  /** Blueprint is an assessment Udemy owns containing a list of learning objectives a user need to learn */
  SkillsFrameworkGoalType["Blueprint"] = "BLUEPRINT";
  /** Small template that DL team generated */
  SkillsFrameworkGoalType["BottomUp"] = "BOTTOM_UP";
  /** Open badge is not owned by Udemy containing a list of learning objectives a user need to learn. */
  SkillsFrameworkGoalType["OpenBadge"] = "OPEN_BADGE";
  /** Generated via AI model */
  SkillsFrameworkGoalType["OrgUpskill"] = "ORG_UPSKILL";
  return SkillsFrameworkGoalType;
}({});

/** A SkillsFramework Id Input is used to identify a skills framework by id and type. */

/** To save a SkillsFramework we need the name and learning objectives associated with it */

/** Response for mapping content to skills framework task reference id status */

/** Content mapping task id and current mapping task status */

/** Status of map content for a reference Id */
export let SkillsFrameworkMapContentTaskStatus = /*#__PURE__*/function (SkillsFrameworkMapContentTaskStatus) {
  /** Task failed */
  SkillsFrameworkMapContentTaskStatus["Failed"] = "FAILED";
  /** Task is in progress */
  SkillsFrameworkMapContentTaskStatus["InProgress"] = "IN_PROGRESS";
  /** Task was killed */
  SkillsFrameworkMapContentTaskStatus["Killed"] = "KILLED";
  /** Task is completed successfully */
  SkillsFrameworkMapContentTaskStatus["Success"] = "SUCCESS";
  return SkillsFrameworkMapContentTaskStatus;
}({});

/** This is the response for updating a skills framework */

/** A skills framework is a collection of learning objectives that are organized into a hierarchy. */

/** Holds a list events by skill node */

/** A skills preparation learning event */

/** Type of a skills preparation learning event */
export let SkillsPrepLearningEventType = /*#__PURE__*/function (SkillsPrepLearningEventType) {
  /** Indicates that the activity was normally completed */
  SkillsPrepLearningEventType["Completed"] = "COMPLETED";
  /** Indicates that the activity was completed with failure */
  SkillsPrepLearningEventType["Failed"] = "FAILED";
  return SkillsPrepLearningEventType;
}({});

/** A list of learning events corresponding to one skill node */

/** Status for a user's skills preparation */
export let SkillsPrepStatus = /*#__PURE__*/function (SkillsPrepStatus) {
  /** The user skills preparation is abandoned */
  SkillsPrepStatus["Abandoned"] = "ABANDONED";
  /** The user skills preparation is completed */
  SkillsPrepStatus["Completed"] = "COMPLETED";
  /** The user skills preparation is started */
  SkillsPrepStatus["Started"] = "STARTED";
  return SkillsPrepStatus;
}({});

/** The filter parameters for skills proficiency insights queries */

/** High-level metrics for skills proficiency across an organization */

/** Represents an Slide with its current time of a Video Mashup asset */

/** Sort direction */
export let SortDirection = /*#__PURE__*/function (SortDirection) {
  /** Ascending sort direction */
  SortDirection["Ascending"] = "ASCENDING";
  /** Descending sort direction */
  SortDirection["Descending"] = "DESCENDING";
  return SortDirection;
}({});

/** SSO-related organization settings */

/** Details about a user's lecture minutes consumption streak, including what to achieve by what date */

/** Status of any type of streak */
export let StreakStatus = /*#__PURE__*/function (StreakStatus) {
  /** The user's streak is ongoing and has not been broken, and they have completed their goals this week */
  StreakStatus["ActiveCurrentPeriodAchieved"] = "ACTIVE_CURRENT_PERIOD_ACHIEVED";
  /** The user's streak is ongoing and has not been broken, but they haven't completed their goals this week */
  StreakStatus["ActiveCurrentPeriodUnachieved"] = "ACTIVE_CURRENT_PERIOD_UNACHIEVED";
  /** The user's streak has expired, they will need to start a new streak from scratch */
  StreakStatus["Dropped"] = "DROPPED";
  /** The user has no history for this type of streak, they never have achieved this streak */
  StreakStatus["ZeroHistory"] = "ZERO_HISTORY";
  return StreakStatus;
}({});

/** SubCategory interface */

/** A wrapper type to include the recommended SubCategory and some additional fields about its recommendation */

/** Subcategory navigation list item. */

/** Subscription plan that the subscriber is subscribed to */

/** Subscriber of the subscription */

/** Subscriber Type */
export let SubscriberType = /*#__PURE__*/function (SubscriberType) {
  /** Organization */
  SubscriberType["Organization"] = "ORGANIZATION";
  /** User */
  SubscriberType["User"] = "USER";
  return SubscriberType;
}({});

/** Billing details of a subscription */

/** Credit card used for the subscription */

/** Subscription object that represents consumer and UB subscriptions */

/** Response for subscription enrollment update mutations */

/** Subscription Feature */

/** Subscription Feature Availability */

/** Subscription Feature Key */
export let SubscriptionFeatureKey = /*#__PURE__*/function (SubscriptionFeatureKey) {
  /** Features related to AI Elevate Experience */
  SubscriptionFeatureKey["AiElevateExperience"] = "AI_ELEVATE_EXPERIENCE";
  /** Features related to AI Elevate Experience V2 */
  SubscriptionFeatureKey["AiElevateExperienceV2"] = "AI_ELEVATE_EXPERIENCE_V2";
  /** AI Starter Paths */
  SubscriptionFeatureKey["AiStarterPaths"] = "AI_STARTER_PATHS";
  /** Assessments */
  SubscriptionFeatureKey["Assessments"] = "ASSESSMENTS";
  /** Category Navigation */
  SubscriptionFeatureKey["CategoryNavigation"] = "CATEGORY_NAVIGATION";
  /** Certificate Content */
  SubscriptionFeatureKey["CertificateContent"] = "CERTIFICATE_CONTENT";
  /** Commenting on instructor announcements */
  SubscriptionFeatureKey["CommentingOnInstructorAnnouncements"] = "COMMENTING_ON_INSTRUCTOR_ANNOUNCEMENTS";
  /** Content Discovery AI Assistant */
  SubscriptionFeatureKey["ContentDiscoveryAiAssistant"] = "CONTENT_DISCOVERY_AI_ASSISTANT";
  /** Course Recommendations during Learning Paths creation */
  SubscriptionFeatureKey["CourseRecommendationsForLearningPathsCreation"] = "COURSE_RECOMMENDATIONS_FOR_LEARNING_PATHS_CREATION";
  /** Create courses */
  SubscriptionFeatureKey["CreateCourses"] = "CREATE_COURSES";
  /** Custom Role Play */
  SubscriptionFeatureKey["CustomRolePlay"] = "CUSTOM_ROLE_PLAY";
  /** DEI features */
  SubscriptionFeatureKey["Dei"] = "DEI";
  /** Direct Messaging Feature */
  SubscriptionFeatureKey["DirectMessaging"] = "DIRECT_MESSAGING";
  /** DRM */
  SubscriptionFeatureKey["Drm"] = "DRM";
  /** Dynamic Lecture Articles */
  SubscriptionFeatureKey["DynamicLectureArticles"] = "DYNAMIC_LECTURE_ARTICLES";
  /** Groups Feature */
  SubscriptionFeatureKey["Groups"] = "GROUPS";
  /** Grow With Google */
  SubscriptionFeatureKey["GrowWithGoogle"] = "GROW_WITH_GOOGLE";
  /** Hide Organization wide learning data */
  SubscriptionFeatureKey["HideOrgWideLearnerData"] = "HIDE_ORG_WIDE_LEARNER_DATA";
  /** Import courses */
  SubscriptionFeatureKey["ImportCourses"] = "IMPORT_COURSES";
  /** In course assignments */
  SubscriptionFeatureKey["InCourseAssignments"] = "IN_COURSE_ASSIGNMENTS";
  /** Learning streaks */
  SubscriptionFeatureKey["LearningStreaks"] = "LEARNING_STREAKS";
  /** Leaving reviews */
  SubscriptionFeatureKey["LeavingReviews"] = "LEAVING_REVIEWS";
  /** Manage Licenses */
  SubscriptionFeatureKey["ManageLicenses"] = "MANAGE_LICENSES";
  /** MCP Base */
  SubscriptionFeatureKey["McpBase"] = "MCP_BASE";
  /** MCP Premium */
  SubscriptionFeatureKey["McpPremium"] = "MCP_PREMIUM";
  /** MCP Server */
  SubscriptionFeatureKey["McpServer"] = "MCP_SERVER";
  /** Mobile app */
  SubscriptionFeatureKey["MobileApp"] = "MOBILE_APP";
  /** ORGANIZATION_BADGES */
  SubscriptionFeatureKey["OrganizationBadges"] = "ORGANIZATION_BADGES";
  /** ORGANIZATION_BADGES FOR LEARNERS */
  SubscriptionFeatureKey["OrganizationBadgesForLearners"] = "ORGANIZATION_BADGES_FOR_LEARNERS";
  /** Question and answer */
  SubscriptionFeatureKey["QuestionAndAnswer"] = "QUESTION_AND_ANSWER";
  /** Recommend */
  SubscriptionFeatureKey["Recommend"] = "RECOMMEND";
  /** Resources */
  SubscriptionFeatureKey["Resources"] = "RESOURCES";
  /** Role Play Enhanced */
  SubscriptionFeatureKey["RolePlayEnhanced"] = "ROLE_PLAY_ENHANCED";
  /** Role Play Unlimited */
  SubscriptionFeatureKey["RolePlayUnlimited"] = "ROLE_PLAY_UNLIMITED";
  /** SCIM Feature */
  SubscriptionFeatureKey["Scim"] = "SCIM";
  /** Showcase Paths */
  SubscriptionFeatureKey["ShowcasePaths"] = "SHOWCASE_PATHS";
  /** Skills benchmarking */
  SubscriptionFeatureKey["SkillsBenchmarking"] = "SKILLS_BENCHMARKING";
  /** Upload badges */
  SubscriptionFeatureKey["UploadBadges"] = "UPLOAD_BADGES";
  /** Video Player Display Ads */
  SubscriptionFeatureKey["VideoPlayerDisplayAds"] = "VIDEO_PLAYER_DISPLAY_ADS";
  return SubscriptionFeatureKey;
}({});

/** Subscription Feature Override */

/** Subscription Feature Override Input */

/** Response for the Subscription Feature Set Overrides mutations */

/** Mobile in-app subscription (through iOS or Android) */

/** Mobile platform that the subscription has been purchased */
export let SubscriptionMobilePlatform = /*#__PURE__*/function (SubscriptionMobilePlatform) {
  /** Google Android */
  SubscriptionMobilePlatform["Android"] = "ANDROID";
  /** Apple iOS */
  SubscriptionMobilePlatform["Ios"] = "IOS";
  return SubscriptionMobilePlatform;
}({});

/** PayPal payment method for the subscription */

/** Payment method of the subscription */

/** Payment type for subscription billing */
export let SubscriptionPaymentType = /*#__PURE__*/function (SubscriptionPaymentType) {
  /** Apple Pay payment */
  SubscriptionPaymentType["ApplePay"] = "APPLE_PAY";
  /** Credit card payment */
  SubscriptionPaymentType["CreditCard"] = "CREDIT_CARD";
  /** Google Pay payment */
  SubscriptionPaymentType["GooglePay"] = "GOOGLE_PAY";
  /** Payment through a native mobile app */
  SubscriptionPaymentType["NativeApp"] = "NATIVE_APP";
  /** PayPal payment over Stripe */
  SubscriptionPaymentType["PaypalOverStripe"] = "PAYPAL_OVER_STRIPE";
  /** UPI payment */
  SubscriptionPaymentType["Upi"] = "UPI";
  return SubscriptionPaymentType;
}({});

/** A Subscription plan to access a catalog of Udemy content */

/** A Subscription plan to access a catalog of Udemy content */

/** Contains information about the discount metadata for a given subscription plan price option */

/** Details of the specific discount type */

/** Contains information on the start and end perioid for the discount interval type can be month/year */

/** Discount details for applied discount */

/** enum definition for different discount types for subscription */
export let SubscriptionPlanDiscountType = /*#__PURE__*/function (SubscriptionPlanDiscountType) {
  /** discount on the plan price monthly/yearly */
  SubscriptionPlanDiscountType["PlanPriceDiscount"] = "PLAN_PRICE_DISCOUNT";
  /** discount on the trial days */
  SubscriptionPlanDiscountType["TrialDiscount"] = "TRIAL_DISCOUNT";
  return SubscriptionPlanDiscountType;
}({});

/** Filers for subscription plans */

/** Contains information about the license context for a given subscription plan price option */

/** Price data for plan pricing options */

/** Contains information on the plan price discount */

/** Definition for different price discount types */
export let SubscriptionPlanPriceDiscountType = /*#__PURE__*/function (SubscriptionPlanPriceDiscountType) {
  /** fixed value discount on the price */
  SubscriptionPlanPriceDiscountType["Fixed"] = "FIXED";
  /** percentage of on the price */
  SubscriptionPlanPriceDiscountType["Percentage"] = "PERCENTAGE";
  return SubscriptionPlanPriceDiscountType;
}({});

/** Union of possible plan pricing options */

/** A subscription plan product family */
export let SubscriptionPlanProductFamily = /*#__PURE__*/function (SubscriptionPlanProductFamily) {
  /** Consumer */
  SubscriptionPlanProductFamily["Consumer"] = "CONSUMER";
  /** Enterprise */
  SubscriptionPlanProductFamily["Enterprise"] = "ENTERPRISE";
  /** Team */
  SubscriptionPlanProductFamily["Team"] = "TEAM";
  return SubscriptionPlanProductFamily;
}({});

/** The type of subscription plan being offered */
export let SubscriptionPlanProductType = /*#__PURE__*/function (SubscriptionPlanProductType) {
  /** Consumer subscription (previously Spadefish) */
  SubscriptionPlanProductType["Consumersubscription"] = "CONSUMERSUBSCRIPTION";
  /** Consumer subscription + Grow With Google content */
  SubscriptionPlanProductType["ConsumersubscriptionPlusGrowWithGoogle"] = "CONSUMERSUBSCRIPTION_PLUS_GROW_WITH_GOOGLE";
  /** Consumer subscription value plan */
  SubscriptionPlanProductType["ConsumersubscriptionValuePlan"] = "CONSUMERSUBSCRIPTION_VALUE_PLAN";
  /** Enterprise Plan */
  SubscriptionPlanProductType["Enterprise"] = "ENTERPRISE";
  /** Enterprise PRO Plan */
  SubscriptionPlanProductType["Enterprisepro"] = "ENTERPRISEPRO";
  /** Enterprise AI growth plan */
  SubscriptionPlanProductType["EnterpriseAiGrowth"] = "ENTERPRISE_AI_GROWTH";
  /** Enterprise AI readiness plan */
  SubscriptionPlanProductType["EnterpriseAiReadiness"] = "ENTERPRISE_AI_READINESS";
  /**
   * Enterprise base plan.
   * This plan serves as a base for other plans and is not available for purchase directly.
   */
  SubscriptionPlanProductType["EnterpriseBase"] = "ENTERPRISE_BASE";
  /** Plan for Grow With Google content only */
  SubscriptionPlanProductType["GrowWithGoogle"] = "GROW_WITH_GOOGLE";
  /** Team Plan */
  SubscriptionPlanProductType["Team"] = "TEAM";
  /**
   * Udemy Pro (deprecated)
   * @deprecated This product type is deprecated.
   */
  SubscriptionPlanProductType["Udemypro"] = "UDEMYPRO";
  return SubscriptionPlanProductType;
}({});

/** contains information on the trial discount if available */

/** Status of the subscription */
export let SubscriptionStatus = /*#__PURE__*/function (SubscriptionStatus) {
  /** Subscription is paid and active */
  SubscriptionStatus["Active"] = "ACTIVE";
  /** Subscription has canceled but still usable until the end date */
  SubscriptionStatus["Canceled"] = "CANCELED";
  /** Subscription has ended and not usable anymore */
  SubscriptionStatus["Expired"] = "EXPIRED";
  /** Subscription has not started yet (only for UB subscriptions) */
  SubscriptionStatus["Future"] = "FUTURE";
  /** Subscription is in free trial period */
  SubscriptionStatus["Trial"] = "TRIAL";
  return SubscriptionStatus;
}({});

/** Type representing details about the trial subscription offer available for a given user and plan */

/** Represents a badge awarded to a top-rated category topic. */

/** Represents a badge awarded to a top-rated subcategory. */

/** Represents a badge awarded to a top-rated subcategory topic. */

/** Topic */

/** A topic descriptor that categorizes topics */

/** Topic Filters for searching topics. All filters are ANDed together. */

/** Topic Group */

/** Response for topic interest update mutations */

/** Types of popularity for Topics */
export let TopicPopularityTypes = /*#__PURE__*/function (TopicPopularityTypes) {
  /** Popular popularity type */
  TopicPopularityTypes["Popular"] = "POPULAR";
  /** Trending popularity type */
  TopicPopularityTypes["Trending"] = "TRENDING";
  return TopicPopularityTypes;
}({});

/** A question and answer pair with optional link for additional context */

/** A wrapper type to include the recommended Topic (aka. Label) and some additional fields about its recommendation */

/** Stats related to a Topic */

/** List of assessment metrics related to a topic */

/** Paginated list for topic-to-assessment summary list */

/**
 * If backend generates a tracking ID for any part of the response, and if the tracking ID ıs needed in the frontend, the
 * object should implement this interface.
 */

/** A Udemy user */

/** Represents the each notification preference of a user */

/** Represents the users notification preference */

/** Input for update for notification preferences  */

/** Response of update user notification preferences */

/** Type of notification preferences */
export let UserNotificationType = /*#__PURE__*/function (UserNotificationType) {
  /** Encapsulates all notifications */
  UserNotificationType["All"] = "ALL";
  /** Notifications that inform about the state of asset */
  UserNotificationType["AssetReady"] = "ASSET_READY";
  /** Notifications that announces an update about specific course */
  UserNotificationType["CourseAnnouncement"] = "COURSE_ANNOUNCEMENT";
  /** Course related messages */
  UserNotificationType["CourseMessageNotification"] = "COURSE_MESSAGE_NOTIFICATION";
  /** Notifications that contain promo for specific course */
  UserNotificationType["CoursePromotion"] = "COURSE_PROMOTION";
  /** Notifications that contain recommendations */
  UserNotificationType["CourseRecommendations"] = "COURSE_RECOMMENDATIONS";
  /** Daily digest informing notifications */
  UserNotificationType["DailyDiscussionsDigest"] = "DAILY_DISCUSSIONS_DIGEST";
  /** Offerings for MX learners to upgrade to UB */
  UserNotificationType["EnterpriseUbOfferings"] = "ENTERPRISE_UB_OFFERINGS";
  /** Notifications sent by instructors to learners */
  UserNotificationType["InstructorAnnouncement"] = "INSTRUCTOR_ANNOUNCEMENT";
  /** Inspiration notifications */
  UserNotificationType["LearningInspiration"] = "LEARNING_INSPIRATION";
  /** Learning statistics notifications */
  UserNotificationType["LearningStats"] = "LEARNING_STATS";
  /** On-site message notifications */
  UserNotificationType["MessageNotification"] = "MESSAGE_NOTIFICATION";
  /** Promo containing notifications */
  UserNotificationType["OffersPromotions"] = "OFFERS_PROMOTIONS";
  /** Notifications that contains announcements */
  UserNotificationType["ProductAnnouncements"] = "PRODUCT_ANNOUNCEMENTS";
  /** Represents notifications containing promotions */
  UserNotificationType["Promotional"] = "PROMOTIONAL";
  /** Video upload status notification */
  UserNotificationType["VideoUploadError"] = "VIDEO_UPLOAD_ERROR";
  return UserNotificationType;
}({});

/** Shows details of the user's occupation */

/** Mutation response for occupation info update */

/** Represents the basic information of a user */

/** Represents different sizes of the same image */

/** Represents a user setting */

/** Object representing Boolean User Setting value */

/** Filter for user settings */

/** The setting names available for a user */
export let UserSettingName = /*#__PURE__*/function (UserSettingName) {
  /** Onboarding checklist setting: completed skills and occupation survey */
  UserSettingName["OnboardingChecklistCompletedSkillsAndOccupationSurvey"] = "ONBOARDING_CHECKLIST_COMPLETED_SKILLS_AND_OCCUPATION_SURVEY";
  /** Onboarding checklist setting: downloaded mobile app */
  UserSettingName["OnboardingChecklistDownloadedMobileApp"] = "ONBOARDING_CHECKLIST_DOWNLOADED_MOBILE_APP";
  /** Onboarding checklist setting: seen onboarding modals */
  UserSettingName["OnboardingChecklistSeenOnboardingModals"] = "ONBOARDING_CHECKLIST_SEEN_ONBOARDING_MODALS";
  return UserSettingName;
}({});

/** Object representing String User Setting value */

/** Union representing possible UserSetting Values */

/** A versioned identifier type */

/** A versioned identifier input */

/** Video lecture */

/** Video lecture */

/** Length of the video in course */
export let VideoLength = /*#__PURE__*/function (VideoLength) {
  /** Extra long */
  VideoLength["ExtraLong"] = "EXTRA_LONG";
  /** Extra short */
  VideoLength["ExtraShort"] = "EXTRA_SHORT";
  /** Long */
  VideoLength["Long"] = "LONG";
  /** Medium */
  VideoLength["Medium"] = "MEDIUM";
  /** Short */
  VideoLength["Short"] = "SHORT";
  return VideoLength;
}({});

/** Mashup lecture has both video and a presentation */

/** Mashup lecture has both video and a presentation */

/** Voucher pool product types */
export let VoucherPoolProductType = /*#__PURE__*/function (VoucherPoolProductType) {
  /** Standard voucher offering/pricing option */
  VoucherPoolProductType["Default"] = "DEFAULT";
  /** Retake insurance offering/pricing option */
  VoucherPoolProductType["RetakeInsurance"] = "RETAKE_INSURANCE";
  return VoucherPoolProductType;
}({});

/** Contains metadata about any retention streak */

/** Price option for computed price plan. Will be returned for weekly plans */

export const SubscriptionFeaturesAvailabilityByKeysDocument = `
    query subscriptionFeaturesAvailabilityByKeys($keys: [SubscriptionFeatureKey!]!) {
  subscriptionFeaturesAvailabilityByKeys(keys: $keys) {
    key
    isAvailable
  }
}
    `;
export const useSubscriptionFeaturesAvailabilityByKeysQuery = (variables, options) => useQuery(['subscriptionFeaturesAvailabilityByKeys', variables], fetcher(SubscriptionFeaturesAvailabilityByKeysDocument, variables), options);
useSubscriptionFeaturesAvailabilityByKeysQuery.getKey = variables => ['subscriptionFeaturesAvailabilityByKeys', variables];
useSubscriptionFeaturesAvailabilityByKeysQuery.fetcher = (variables, options) => fetcher(SubscriptionFeaturesAvailabilityByKeysDocument, variables, options);
//# sourceMappingURL=api-platform-graphql.js.map